/*!-----------------------------------------------------------------------------
 * Diamond Social Feed.
 * v1.0 - built March 15, 2019
 * --------------------------------------------------------------------------*/

(function ($) {
    'use strict';

    // Default options
    var defaults = {
        
        // Styling options for the carousel grid
        carouselWidth: 100,
        gridStyle: 'diamond',
        gridColumns: 4,
        slideDistance: 'min',
        gridGlobalSpeed: 250,
        gridScrollSpeed: 300,
        gridScrollTransitionStyle: 'cubic-bezier(.5,.2,.5,.8)',
        fontFamily: null,

        // Styling options for the carousel slides 
        itemSize: 90,
        itemBorderRadius: 4,
        itemColor: '#000000',
        itemGradientOpacity: 0.25,
        itemShadowSize: 4,
        itemShadowOpacity: 0.25,
        itemHover: true,
        itemHoverOpacity: 0.1,
        itemHoverSpeed: 250,
        itemText: 'View',
        itemTextColor: '#ffffff',
        itemFontSize: 14,
        itemHoverTextAnimation: 'zoomIn',

        // Aspect ratio option. Only for the 'tile' style carousel
        itemAspectRatio: [3,2],

        // Styling options for the carousel control buttons
        controlPrevText: 'Prev',
        controlNextText: 'Next',
        controlTextColor: '#ffffff',
        controlDisableTextColor: '#101010',
        controlFontSize: 9,
        controlBgColor: '#2f353a',
        controlGradientColor: '#000000',
        controlGradientOpacity: 0.95,

        // Gradient size for control buttons arrows. Recommended maximum value: 30
        controlArrowsSize: 30,

        // Keyboard control option. This option will be applied to the carousel and lightbox
        keyboardControl: true,

        // Minimum move distance to run the carousel swipe event. In percent of slide size
        touchThreshold: 10,

        // Styling options for lightbox
        lightBoxSpeed: 250,
        lightBoxTransitionStyle: 'cubic-bezier(.5,.2,.5,.8)',
        lightBoxOverlayColor: '#000000',
        lightBoxOverlayOpacity: 0.95,
        lightBoxImageAspectRatio: [0.8, 0.9],
        lightBoxImageFadeScale: 0.9,
        lightBoxControlColor: '#c2c2c2',
        lightBoxControlSize: 45,
        lightBoxCloseSize: 30,
        lightBoxControlWidth: 3,
        lightBoxCounter: true,
        lightBoxCounterText: ' of ',
        lightboxCounterPlus: true,
        lightBoxTransitionDistance: 10,
        lightBoxSocialLinkText: 'View on',

        // Breakpoints
        breakPoints: {
            1024: {
              gridColumns: 4,
              lightBoxControlSize: 45,
              lightBoxCloseSize: 30,
              lightBoxControlWidth: 4
            },
            768: {
              gridColumns: 3,
              lightBoxControlSize: 50,
              lightBoxCloseSize: 60,
              lightBoxControlWidth: 3
            },
            480: {
              gridColumns: 2,
              lightBoxControlSize: 70,
              lightBoxCloseSize: 70,
              lightBoxControlWidth: 2
            }
        },

        // Settings and styling options for social networks
        socialIcon: true,
        socialIconSize: 5,
        socialIconBottom: 8,
        socialIconOpacity: 0.6,
        socialControlColor: '#ffffff',
        socialControlOpacity: 0.9,
        playButtonSize: 60,
        elapsedTimeFewSec: 'FEW SECONDS AGO',
        elapsedTimeLessThanMin: 'LESS THAN ONE MIN',
        elapsedTimeMinAgo: 'MINUTES AGO',
        elapsedTimeHrsAgo: 'HOURS AGO',
        elapsedTimeDaysAgo: 'DAYS AGO',
        elapsedTimeMnthAgo: 'MONTH AGO',
        elapsedTimeYrsAgo: 'YEARS AGO',

        facebookAccessToken: null,
        facebookAlbumID: null,
        facebookPhotos: true,
        hideFacebookCoverPic: false,
        hideFacebookProfilePic: false,
        facebookVideos: true,    

        youtubeApiKey: null,
        youtubeChannelId: '',
        youtubeUserId: '',
        youtubeListId: '',
        youtubeQuery: '',

        vimeoAccessToken: null,
        vimeoQuery: '',
        vimeoChannelId: '',
        vimeoUserId: ''
    };

    // This function configures the plugin structure depending on the options
    var Diamond = function ( elmt, options ) {

        this.options = $.extend(true, {}, defaults, options);

        // Configuration of the carousel wrapper
        this.elmt = elmt;
        this.$elmt = $(elmt);
        this.$elmt.wrapInner( '<div class="scroll-area"></div>' );
        this.$elmt.addClass( this.options.gridStyle + '-feed' );
        
        // Configuration of the carousel scroll area
        this.$scrollArea = this.$elmt.children();
        this.$scrollArea.css( 'transform', 'translate3d(0px, -50%, 0px)' );
        
        // Configuration of the carousel control buttons
        this.$controlPrev = $('<div class="prev"></div>');
        this.$controlNext = $('<div class="next"></div>');
        this.keyIsDown = false;
        this.$cntrlButtonsBg = $('<div class="' + this.options.gridStyle + '-controls-bg"></div>');
        this.$cnrtlButtonTxtWrpr = $('<div class="' + this.options.gridStyle + '-control-txt-wrpr"></div>');
        this.$cnrtlButtonTxt = $('<div class="' + this.options.gridStyle + '-control-txt"></div>');
        this.controlTextColor = this.hexToRgbA(this.options.controlTextColor, 1);
        this.controlTextColorTrnt = this.hexToRgbA(this.options.controlTextColor, 0);
        this.controlDisableTextColor = this.hexToRgbA(this.options.controlDisableTextColor, 1);
        this.controlDisableTextColorTrnt = this.hexToRgbA(this.options.controlDisableTextColor, 0);
        this.controlGradientColor = this.hexToRgbA(this.options.controlGradientColor, this.options.controlGradientOpacity);
        this.controlGradientColorTrnt = this.hexToRgbA(this.options.controlGradientColor, 0);

        // Configuration of the carousel slides
        this.index = 0;
        this.items = this.$scrollArea.children();
        this.init_grid_size = this.grid_sizing();
        this.totalMedia = this.items.length;
        this.itemInnerClass = this.options.gridStyle + '-item-inner';
        this.itemPreviewClass = this.options.gridStyle + '-preview'; 
        this.itemAspectRatio = this.options.itemAspectRatio[0] / this.options.itemAspectRatio[1];
        this.tileHeight = 100 - ( 100 - this.options.itemSize ) * this.itemAspectRatio;
        this.itemMagrin = ( 100 - this.options.itemSize ) / 2;
        this.itemGradient = this.hexToRgbA(this.options.itemColor, this.options.itemGradientOpacity);
        this.itemGradientTrnt = this.hexToRgbA(this.options.itemColor, 0);
        this.shadowColor = this.hexToRgbA(this.options.itemColor, this.options.itemShadowOpacity);
        this.itemTextColor = this.hexToRgbA(this.options.itemTextColor, 1);
        this.itemInConfiguration = this[ this.options.gridStyle + '_el_sizes' ]( this.grid_sizing() );
        this.itemInWidth = this.itemInConfiguration[0];
        this.itemInHeight = this.itemInConfiguration[1];
        this.itemInMargin = this.itemInConfiguration[2];
        this.itemInFontSize = this.itemInConfiguration[3];
        this.itemInShadow = this.itemInConfiguration[4];
        this.itemInHalfShadow = this.itemInConfiguration[5];
        this.itemInControlFontSize = this.itemInConfiguration[6];

        // Animation of preview text of carousel slides
        this.itemTextAnimation = {
            zoomIn:[ 'scale(0.9) translate3d(0, 0, 0)', 'scale(1) translate3d(0, 0, 0)' ],
            zoomOut:['scale(1.1) translate3d(0, 0, 0)', 'scale(1) translate3d(0, 0, 0)' ],
            fromRight:[ 'translate3d(10%, 0, 0)', 'translate3d(0%, 0, 0)' ],
            fromLeft:[ 'translate3d(-10%, 0, 0)', 'translate3d(0%, 0, 0)' ],
            fromTop:[ 'scale(0.95) translate3d(0, -50%, 0)', 'scale(1) translate3d(0, 0%, 0)' ],
            fromBottom:[ 'scale(0.95) translate3d(0, 50%, 0)', 'scale(1) translate3d(0, 0%, 0)' ]
        };

        // Carousel wrapper building
        this.wrapper_width();
        this.wrapper_shadow_padding();
        this[ this.options.gridStyle + '_wrapper_height' ]( this.grid_sizing() ); 

        // Carousel scroll area building
        this[ this.options.gridStyle + '_scroll_area_height' ]( this.grid_sizing() );
        this.scroll_area_width();
        this.$scrollArea.css('transition', 'transform ' + this.options.gridScrollSpeed + 'ms ' + this.options.gridScrollTransitionStyle);

        // Run 'diamond' or 'tile' carousel slides and control buttons building
        this[ this.options.gridStyle ]();

        // Carousel swipe event configuration
        this.moveX = 0;
        this.translateX = 0;
        this.startX = 0;
        this.endX = 0;
        this.startY = 0;
        this.letItGo = null;
        this.mouseDown = false;
        this.carouselIsSliding = false;
        this.itemsLoading = false;
        this.carouselOnEnd = false;
        if( this.options.lightBoxSpeed == 0 )
        this.options.lightBoxSpeed = 0.01;

        // Lightbox configuration
        this.lightBoxWrapper = $('<div>').addClass( this.options.gridStyle + ' lightbox-wrapper');
        if( this.options.fontFamily )
        this.lightBoxWrapper.css('font-family', this.options.fontFamily);
        this.lightBoxSpinner = $('<div>').addClass('lightbox-spinner').html('<div></div>');
        this.lightBoxImage = $('<div>').addClass('lightbox-image');
        this.lightBoxOverlay = $('<div>').addClass('lightbox-overlay');  
        this.closeLightBox = $('<div>').addClass('lightbox-close').html('<div><span></span><span></span></div>');
        this.LightBoxCntlPrev = $('<div>').addClass('lightbox-control prev').html('<div><span></span><span></span></div>');
        this.LightBoxCntlNext = $('<div>').addClass('lightbox-control next').html('<div><span></span><span></span></div>');
        this.LightBoxCounter = $('<div>').addClass('lightbox-counter');
        this.controlLightBoxColor = this.hexToRgbA(this.options.lightBoxControlColor, 1);
        this.controlLightBoxColorTrnt = this.hexToRgbA(this.options.lightBoxControlColor, 0);
        this.VideoFrame = $('<div>').addClass('video-frame');

        // Lightbox swipe event configuration
        this.lightBoxMoveX = 0;
        this.lightBoxTranslateX = 0;
        this.lightBoxStartX = 0;
        this.lightBoxEndX = 0;
        this.lightBoxStartY = 0;
        this.lightBoxMouseDown = false;
        this.lightBoxOpened = false;
        this.lightBoxOnTrstn = false;
        this.lightBoxLoading = false;
        this.ableToCloseLB = true;

        // Social networks configuration
        this.socialAvailable = false;
        this.socialDataLoading = false;
        this.currSocNet = 0;
        this.currSocNetName = '';
        this.totalDataLoaded = this.items.length;
        this.loadingComments = false;
        this.itemsLoadCnt = 0;

        // Determining which social networks were set in options
        var self = this;
        if ( options !== undefined ) {
            
            this.socialNetworks = Object.keys(options).map( function( el ) {

                switch (el) {
                    case 'facebookAccessToken':

                        if( self.options.facebookPhotos && self.options.facebookVideos )
                        return ['facebookPhotos', 'facebookVideos'];
                        
                        if( self.options.facebookPhotos )
                        return 'facebookPhotos';

                        if( self.options.facebookAlbumID )
                        return 'facebookPhotos';

                        if( self.options.facebookVideos )
                        return 'facebookVideos';

                        break;
                    case 'youtubeApiKey':
                        if( self.options.youtubeListId || self.options.youtubeChannelId || self.options.youtubeUserId || self.options.youtubeQuery )
                        return 'youtube';
                        break;
                    case 'vimeoAccessToken':
                        if( self.options.vimeoUserId || self.options.vimeoChannelId || self.options.vimeoQuery )
                        return 'vimeo';
                        break;
                };
            }).filter(Boolean);

            this.socialNetworks = [].concat.apply([], this.socialNetworks);

            if ( this.socialNetworks.length )
            this.socialAvailable = true;
        };

        // Creation of the play video icon
        this.PlayButton = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        this.PlayButton.setAttribute('viewBox','-49.5 -29.5 100 100');
        this.PlayButtonPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        this.PlayButtonPath.setAttribute('d','M48.193,16.77L-43.5-29.063c-3.141-1.452-6,0.991-6,3.563v92c0,2.969,'+
                                       '3.594,4.859,6.03,3.562l91.663-45.835 C49.609,23.52,50.5,22.082,50.5,'+
                                       '20.5C50.5,18.919,49.609,17.478,48.193,16.77z');
        this.PlayButton.appendChild(this.PlayButtonPath);

        // Creation of the comments icon
        this.CommentsIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        this.CommentsIcon.setAttribute('viewBox','-349.5 50.5 400 400');
        this.CommentsIconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        this.CommentsIconPath.setAttribute('d','M-149.5,74.5c-110.48,0-200,69.12-200,152c0,51.607,31.086,'+
                                           '96.978,84,124c0,0.289-0.249,20.251-20,60 c-4.248,7.999,2,16,12,'+
                                           '16c22.751,0,73.501-30.501,92-52c102.496,14,232-44.004,'+
                                           '232-148C50.461,143.62-39.024,74.5-149.5,74.5z M-193.5,'+
                                           '346.5c-8.248,19.749-61.248,52.5-56,44c11.5-21.249,8-56,'+
                                           '8-56s-82-35.002-84-107.999c0-68.911,79.523-128.001,176-128.001 '+
                                           'c96.512,0,176,59.09,176,128.001C26.5,303.998-87.58,371.3-193.5,346.5z');
        this.CommentsIcon.appendChild(this.CommentsIconPath);

        // Creation of the like icon
        this.LikeIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        this.LikeIcon.setAttribute('viewBox','-349.5 50.5 400 400');
        this.LikeIconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        this.LikeIconPath.setAttribute('d','M34.5,274.5c28.667-41.69-4.002-72-44-72h-88c28.667-84.322-4.665'+
                                           '-152-40-152c-22.499,0-32,15-32,52c0,58-37.502,100-80,100 '+
                                           'h-56c-22.503,0-40,16.653-40,44l12,136c3.249,25.999-0.999,68.016,'+
                                           '44,68h28c14.238,0,32-16,32-16s30.5,16,52,16h124 '+
                                           'c64.494,0,64.163-44.169,52-60c44.83-11.672,29.664-49.34,24-52C60.831,'+
                                           '315.489,43.652,280.616,34.5,274.5z M-263.5,426.5 '+
                                           'c0,0-25.836,0-26,0c-16.664-0.015-16.752-14.001-20-48l-12-124c-3.'+
                                           '248-28.498,24-28,24-28h48v192 C-249.5,418.5-256.5,426.5-263.5,426.5z '+
                                           'M-5.5,320.5v18c5.334,0,32.119,32.561-24,32v20c11,4.333,18,36-24,36h-124 '+
                                           'c-22.5,0-48-18-48-18v-182c0,0,80-26,80-124c0-21.5,11.5-42.5,24-12c29.999,'+
                                           '59.33-12,136-12,136h128c36.668,0,31.335,39,12,39v20 '+
                                           'C33.5,285.5,34.167,320.5-5.5,320.5z');
        this.LikeIcon.appendChild(this.LikeIconPath);

        // Creation of the disike icon
        this.DislikeIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        this.DislikeIcon.setAttribute('viewBox','-349.5 50.5 400 400');
        this.DislikeIconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        this.DislikeIconPath.setAttribute('d','M-333.5,226.5c-28.667,41.69,4.002,72,44,72h88c-28.667,84.322,4.665,152'+
                                         ',40,152c22.499,0,32-15,32-52 c0-58,37.502-100,80-100h56c22.503,0,40-16.653,'+
                                         '40-44l-12-136c-3.249-25.999,0.999-68.016-44-68h-28c-14.238,0-32,16-32,16 '+
                                         's-30.5-16-52-16h-124c-64.494,0-64.163,44.169-52,60c-44.83,11.672-29.664,'+
                                         '49.34-24,52 C-359.831,185.511-342.652,220.384-333.5,226.5z M-35.5,74.5c0,'+
                                         '0,25.836,0,26,0c16.664,0.015,16.752,14.001,20,48l12,124 c3.248,28.498-24,'+
                                         '28-24,28h-48v-192C-49.5,82.5-42.5,74.5-35.5,74.5z M-293.5,180.5v-18c-5.334,'+
                                         '0-32.119-32.561,24-32v-20 c-11-4.333-18-36,24-36h124c22.5,0,48,18,48,'+
                                         '18v182c0,0-80,26-80,124c0,21.5-11.5,42.5-24,12c-29.999-59.33,12-136,'+
                                         '12-136h-128 c-36.668,0-31.335-39-12-39v-20C-332.5,215.5-333.167,180.5-293.5,'+
                                         '180.5z');
        this.DislikeIcon.appendChild(this.DislikeIconPath);

        // Creation of the favourite icon
        this.FavoriteIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        this.FavoriteIcon.setAttribute('viewBox','0 0 400 400');
        this.FavoriteIconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        this.FavoriteIconPath.setAttribute('d','M400,138c0-109-124.25-153.75-200-78C124.25-15.75,0,29,0,138c0,57.5,'+
                                               '46,95,46,95l154,148l154-148 C354,233,400,192.5,400,138z M335,220L200,'+
                                               '350L65,220c0,0-46-46.5-41-82C24,43.5,137.5,7,200,97c66.5-93,176-49,176,'+
                                               '41 C377.5,183,335,220,335,220z');
        this.FavoriteIcon.appendChild(this.FavoriteIconPath);

        // Thumbnail if video or image is not found
        self.notFoundPrev = 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAsLCwsMCw0ODg0SExETEhoYFhYYGiccHh'+
                            'weHCc8JSslJSslPDVANDA0QDVfSkJCSl9tXFdcbYR2doSnnqfa2v8BCwsLCwwLDQ4ODRITERMSGhgWFhgaJxweHB4'+
                            'cJzwlKyUlKyU8NUA0MDRANV9KQkJKX21cV1xthHZ2hKeep9ra///CABEIAZACxgMBIgACEQEDEQH/xAAVAAEBAAAA'+
                            'AAAAAAAAAAAAAAAAB//aAAgBAQAAAACRAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'+
                            'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'+
                            'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'+
                            'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'+
                            'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'+
                            'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'+
                            'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'+
                            'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'+
                            'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD//xAAUAQEAAAAAAAAAAAAAAAAAA'+
                            'AAA/9oACAECEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'+
                            'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'+
                            'AAAAAAAAAAAAAAAAAAAAAAAAAB//EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAIAQMQAAAAAAAAAAAAAAAAAAAAAAAA'+
                            'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'+
                            'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH/8QAFBABAA'+
                            'AAAAAAAAAAAAAAAAAAwP/aAAgBAQABPwALF//EABQRAQAAAAAAAAAAAAAAAAAAAKD/2gAIAQIBAT8ADL//xAAUEQE'+
                            'AAAAAAAAAAAAAAAAAAACg/9oACAEDAQE/AAy//9k=';

        // Determining viewport width
        if ( $(document).width() > 768) {
            this.isMobile = false;
        } else {
            this.isMobile = true;
        };

        // Facebook configuration
        this.facebookPhotosTotal = null;
        this.facebookPhotosDataLoaded = 0;
        this.facebookPhotosPrecount = 0;
        this.facebookPhotosNextPage = '';
        this.isFacebookPhotosLeft = true;
        this.facebookPhotosCounted = false;
        this.facebookVideosTotal = null;
        this.facebookVideosDataLoaded = 0;
        this.facebookVideosPrecount = 0;
        this.facebookVideosNextPage = '';
        this.isFacebookVideosLeft = true;
        this.facebookVideosCounted = false;
        this.facebookProfileCoverPhoto = null;

        // YouTube configuration
        this.youtubeRequest = [ 'search', '' ];
        if (this.options.youtubeListId)
        this.youtubeRequest = [ 'playlistItems', '&playlistId=' + this.options.youtubeListId ];
        if (this.options.youtubeChannelId)
        this.youtubeRequest = [ 'search', '&channelId=' + this.options.youtubeChannelId ];
        if (this.options.youtubeUserId)
        $.ajax({
            type: "GET",
            dataType: "jsonp",
            cache: false,
            crossDomain: true,
            url: 'https://www.googleapis.com/youtube/v3/channels?part=snippet&forUsername=' + 
                  self.options.youtubeUserId  +
                 '&key=' + self.options.youtubeApiKey,
            success: function(data) {
                if ( data.items && self.socialAvailable )
                self.youtubeRequest = [ 'search', '&channelId=' + data.items[0].id ],
                self.get_social_data( self.grid_sizing() * 3 - self.totalMedia );
            },
            error: function (data) {  
                console.log(data);
                self.get_social_data( self.grid_sizing() * 3 - self.totalMedia );
            }
        });
        if (this.options.youtubeQuery)
        this.options.youtubeQuery = '&q=%23' + this.options.youtubeQuery;
        this.youtubeTotal = null;
        this.youtubeDataLoaded = 0;
        this.youtubeNextPage = '';
        this.youtubePrivateVideoCount = 0;

        // Vimeo configuration
        this.vimeoRequest = '';
        if(this.options.vimeoChannelId)
        this.vimeoRequest = 'channels/' + this.options.vimeoChannelId + '/';
        if(this.options.vimeoUserId)
        this.vimeoRequest = 'users/' + this.options.vimeoUserId + '/';
        if(this.options.vimeoQuery)
        this.options.vimeoQuery = '&query=' + this.options.vimeoQuery;
        this.vimeoTotal = null;
        this.vimeoDataLoaded = 0;
        this.vimeoNextPage = '';

        // Initialization of the plugin
        this.init();
    };

    Diamond.prototype = {
        
        // This function initializes the plugin
        init: function( elmt ) {

            // Window resize listener
            var self = this;
            var onResize;
            $(window).resize(function() {

                self.$scrollArea.css( 'transition', '' );
                clearTimeout(onResize);

                onResize = setTimeout(function(){

                    self.resize( self.options.gridStyle );

                    $.when( self.resize( self.options.gridStyle ) ).done(function() {
                        self.$scrollArea.css( 
                            'transition', 'transform ' + self.options.gridScrollSpeed + 
                                          'ms ' + self.options.gridScrollTransitionStyle 
                        );
                        self.lightBoxImage.css( 'transition', self.options.lightBoxSpeed + 'ms ease-in-out' );
                    });

                }, 100);
            });

            // Setting up a font family for the gallery
            if( this.options.fontFamily )
            this.$elmt.css('font-family', this.options.fontFamily);

            // Uploading non-social images to fill the carousel
            this.items.slice( 0, this.grid_sizing() * 3 ).each( function() { 
                self.item_load( this );
            });

            // Adjusting the last column of the carousel
            if ( this.totalMedia / 3 < Math.round( this.totalMedia / 3 ) && !this.socialAvailable )
            this.adjustLastColumn();

            // Social data loading
            if ( this.socialAvailable && !this.options.youtubeUserId )
            this.get_social_data( this.grid_sizing() * 3 - this.totalMedia );

            // Activation of the carousel 'next' button 
            if ( this.totalMedia >= this.grid_sizing() * 3 )
            this.control_btn_enable( this.$controlNext );

            // Applying slides hover effects
            if ( this.options.itemHover )
            this.item_hover( this.itemTextAnimation[this.options.itemHoverTextAnimation][1], 
                             this.itemTextAnimation[this.options.itemHoverTextAnimation][0] );

            // Control buttons launching
            this.$controlNext.children(':first').on( 'click', this.slide_next.bind(this) );
            this.$controlPrev.children(':first').on( 'click', this.slide_prev.bind(this) );

            // Keyboard control launching
            if( this.options.keyboardControl )
            this.keyboard_control();

            // Binding carousel touch events
            this.$scrollArea
                .on('touchstart', this.carousel_touch_start.bind(this))
                .on('touchmove', this.carousel_touch_move.bind(this));

            // Binding carousel mouse events
            this.$scrollArea
                .on('mousedown', this.carousel_mouse_down.bind(this))
                .on('mousemove', this.carousel_mouse_move.bind(this))
                .on('mouseleave', this.carousel_mouse_leave.bind(this));

            // Binding carousel swipe event    
            this.$scrollArea.on('mouseup touchend', this.carousel_swipe.bind(this));

            // Show lightbox on clicking slides
            this.$scrollArea.on( 'click', '.' + this.options.gridStyle + '-item-inner', this.show_lightbox.bind(this) );
        },
        // This function calculates width of the gallery container
        wrapper_width: function() {

            var containerWidth = this.$elmt.parent().outerWidth();
            var elementWidth = containerWidth / 100 * this.options.carouselWidth;

            this.$elmt.css( 'width', elementWidth + 'px' );
        },
        // This function calculates the padding of the gallery container based on the size of the shadows of the slides
        wrapper_shadow_padding: function() {

            var padding = $(window).width() / 100 * ( this.options.itemShadowSize * 2 );

            this.$elmt.css( 'padding', padding.toFixed() + 'px 0' );
        },
        // This function run building of carousel slides and control buttons with 'diamond' style
        diamond: function() {

            var self = this,
                tltX = 100 - this.options.itemSize;

            this.items.each( function() { 
                self.grid_item( this, self.options.itemSize, self.itemMagrin + '%', 'to bottom', tltX, tltX );
            });

            this.control_buttons( this.options.itemSize, this.itemMagrin + '%' );
        },
        // This function calculates the height of the 'diamond' carousel wrapper
        diamond_wrapper_height: function( columns ) {

            var wrapper_height = this.$elmt.outerWidth() / columns;
            var item_size = wrapper_height - wrapper_height / 100 * this.options.itemSize;
                wrapper_height = wrapper_height * 3.1 - item_size * 1.1 - wrapper_height * 1.05 * 0.86;

            this.$elmt.css( 'height', wrapper_height + 'px' );    
        },
        // This function calculates the height of the 'diamond' carousel scrolling area
        diamond_scroll_area_height: function( columns ) {

            var scroll_area_height = this.$elmt.outerWidth() / columns * 3;
                scroll_area_height = Math.ceil(scroll_area_height);

            this.$scrollArea.css( 'height', scroll_area_height + 'px' );
        },
        // This function calculates dimensions of the slides of the 'diamond' carousel
        diamond_el_sizes: function( columns ) {

            var container_width = this.$elmt.outerWidth();
                
            var item_width = container_width / columns;
                item_width = Math.sqrt( item_width * item_width / 2 ) * 1.05;
                item_width = item_width.toFixed();

            var item_margin = container_width - item_width * columns; 
                item_margin = item_margin / ( columns * 2 );

            var item_fs = item_width / 10000 * this.options.itemSize * this.options.itemFontSize;
                item_fs = item_fs.toFixed();

            var controls_fs = item_width / 10000 * this.options.itemSize * this.options.controlFontSize;
                controls_fs = controls_fs.toFixed();

            var box_shadow = $(window).width() / 100 * this.options.itemShadowSize;
                box_shadow = box_shadow.toFixed();
            
            var half_shadow = ( box_shadow / 2 ).toFixed();

            return [ item_width, item_width, item_margin, item_fs, box_shadow, half_shadow, controls_fs ]
        },
        // This function run building of carousel slides and control buttons with 'tile' style
        tile: function() {

            // Check if aspect ratio value is correct
            if ( this.options.itemAspectRatio[0] < this.options.itemAspectRatio[1] )
            throw new Error('Incorrect aspect ratio value');

            var self = this,
                tltX = 100 - this.options.itemSize;

            this.items.each(function(){
                self.grid_item( this, self.tileHeight, 0, '135deg', tltX, 0 );
            });

            this.control_buttons( this.tileHeight, 0 );
        },
        // This function calculates the height of the 'tile' carousel wrapper
        tile_wrapper_height: function( columns ) {

            var wrapper_height = this.$elmt.outerWidth() / columns / this.itemAspectRatio;
            var item_height = wrapper_height - wrapper_height / 100 * this.tileHeight;
                wrapper_height = wrapper_height * 3 - item_height;

                this.$elmt.css( 'height', wrapper_height.toFixed() + 'px' );
        },
        // This function calculates the height of the 'tile' carousel scrolling area
        tile_scroll_area_height: function( columns ) {

            var scroll_area_height = this.$elmt.outerWidth() / columns / this.itemAspectRatio;
                scroll_area_height = scroll_area_height * 3;

                this.$scrollArea.css( 'height', scroll_area_height + 'px' );
        },
        // This function calculates dimensions of the slides of the 'tile' carousel
        tile_el_sizes: function( columns ) {

            var item_width = this.$elmt.outerWidth() / columns;

            var item_height = item_width / this.itemAspectRatio;

            var item_fs = item_width / 10000 * this.options.itemSize * this.options.itemFontSize;

            var controls_fs = item_width / 10000 * this.options.itemSize * this.options.controlFontSize;

            var box_shadow = ( $(window).width() / 100 * this.options.itemShadowSize ).toFixed();
            var half_shadow = ( box_shadow / 2 ).toFixed();

            return [ item_width, item_height, 0, item_fs, box_shadow, half_shadow, controls_fs ]           
        },
        // This function calculates the width of the carousel scrolling area
        scroll_area_width: function() {

            var item_width = this.$elmt.outerWidth() / this.grid_sizing(),
                top_items = this.$scrollArea.children(':nth-child(3n+1)').length,
                middle_items = this.$scrollArea.children(':nth-child(3n+2)').length + 1,
                scroll_area_width;

                if ( top_items > middle_items ) {
                    scroll_area_width = top_items * item_width;
                } else {
                    scroll_area_width = top_items * item_width + item_width;
                };

            this.$scrollArea.css( 'min-width', scroll_area_width.toFixed() + 'px' );
        },
        // This function calculates the size of the carousel grid
        grid_sizing: function() {

            var self = this;
            var BrPtColumns = this.options.gridColumns;

            var breakpoints = $.map(self.options.breakPoints, function(el,i) { return i });
                breakpoints = $.grep(breakpoints, function(val) { return val >= self.$elmt.outerWidth() });

            if ( self.options.breakPoints[breakpoints[0]] )
            return  BrPtColumns = self.options.breakPoints[breakpoints[0]]['gridColumns']
            return BrPtColumns;
        },
        // This function adjusts the last column of the carousel grid
        adjustLastColumn: function() {

            if( this.$scrollArea.children('.grid-adguster').length )
            return;

            $('<div>').addClass('grid-adguster')
                      .css({
                            'width': this.itemInWidth + 'px',
                            'height': this.itemInHeight + 'px',
                            'margin': this.itemInMargin + 'px',
                            'visibility': 'hidden'
                      })
                      .insertBefore( this.$scrollArea.children(':last') );
        },
        // This function is intended to build a carousel slide
        grid_item: function( item, itemHeight, itemMargin, gradientAngle, tltX, tltY ) {

            var itemInner = $('<div></div>').addClass(this.itemInnerClass),
                itemPreview = $('<div></div>').addClass(this.itemPreviewClass),
                itemText = $('<p></p>').text(this.options.itemText),
                itemSocialIcon = $(item).children('svg'),
                socialNetwork = itemSocialIcon.attr('class');

            itemSocialIcon.css({
                'width': this.options.socialIconSize + '%',
                'bottom': this.options.socialIconBottom + '%',
                'fill': this.options.itemTextColor,
                'opacity': this.options.socialIconOpacity
            });

            if (this.options.gridStyle == 'tile')
            itemSocialIcon.css( 'right', this.options.socialIconBottom + '%' ); 

            itemInner.addClass(socialNetwork).css({
                'visibility': 'hidden',
                'opacity': 0,
                'transform': 'translate(' + tltX + '%,-' + tltY + '%)',
                'width': this.options.itemSize + '%',
                'height': itemHeight + '%',
                'margin': itemMargin,
                'border-radius': this.options.itemBorderRadius + 'px',
                'background-color': this.options.itemColor,
                'color': this.shadowColor,
                'box-shadow': this.itemInHalfShadow + 'px ' + 
                              this.itemInHalfShadow + 'px ' + 
                              this.itemInShadow  + 'px',
                'transition': this.options.gridGlobalSpeed + 'ms ' + this.options.gridScrollTransitionStyle,
                'transition-delay': this.options.gridGlobalSpeed / 2 + 'ms',
            });

            itemPreview.css( 
                'background-image', 'linear-gradient(' + 
                                    gradientAngle + ', ' + 
                                    this.itemGradientTrnt + ' 45%,' + 
                                    this.itemGradient + ' 100%)' 
            );

            itemText.css({
                'color': this.itemTextColor,
                'transform': this.itemTextAnimation[this.options.itemHoverTextAnimation][0]
            });

            itemPreview.html([itemText, itemSocialIcon]);
            itemInner.html(itemPreview);

            $(item).prepend(itemInner)
                   .addClass(this.options.gridStyle + '-item')
                   .css({
                        'width': this.itemInWidth + 'px',
                        'height': this.itemInHeight + 'px',
                        'margin': this.itemInMargin + 'px',
                        'font-size': this.itemInFontSize + 'px'
                   });

            if ( $(item).has('.caption').length )
            $(item).addClass('social');

            return $(item);
        },
        // This function is for loading images of carousel slides
        item_load: function( item ) {

            var self = this,
                src = $(item).attr('data-img'),
                image = $('<div></div>').addClass( this.options.gridStyle + '-item-image' ),
                background = new Image();
                background.src = src;

            $(this).remove();

            this.itemsLoading = true;
            image.css('background-image', 'url(' + src + ')');

            $(item).children(':first').prepend(image);

            if( this.options.gridScrollSpeed == 0 || self.options.gridGlobalSpeed == 0 )
            this.itemsLoading = false;

            $(item).removeAttr('data-img');

            $(background).on('load', function() {
                
                image.css('background-image', 'url(' + src + ')');

                $(item).children(':first')
                       .css({
                            'visibility': '',
                            'opacity': 1,
                            'transform': ''
                       })
                       .one('transitionend', function() {
                            self.itemsLoading = false;
                            $(this).css('transition', '');
                       });
    
            }).on('error', function() {

                image.css('background-image', 'url(' + self.notFoundPrev + ')');

                $(item).children(':first')
                       .css({
                            'visibility': '',
                            'opacity': 1,
                            'transform': ''
                       })
                       .one('transitionend', function() {
                            self.itemsLoading = false;
                            $(this).css('transition', '');
                       });
            });
        },
        // This function calculates the size of the carousel slide
        grid_item_sizing: function( item, width, height, margin, fontSize, shadow, halfShadow ) {

            $(item).css({
                'width': width + 'px',
                'height': height + 'px',
                'margin': margin + 'px',
                'font-size': fontSize + 'px'
            });

            $(item).find('.' + this.itemInnerClass).css( 
                'box-shadow', halfShadow + 'px ' + halfShadow + 'px ' + shadow + 'px' 
            );
        },
        // This function is intended to build control buttons of the carousel
        control_buttons: function( itemHeight, itemMargin ) {

            this.$cnrtlButtonTxt.css({
                                    'width': this.options.itemSize + '%',
                                    'height': itemHeight + '%',
                                    'margin': itemMargin,
                                    'color': this.options.controlDisableTextColor,
                                    'background-image': 'linear-gradient(to right, ' + 
                                                        this.controlDisableTextColorTrnt + ' 0%,' + 
                                                        this.controlDisableTextColor   + ' ' + 
                                                        this.options.controlArrowsSize + '%,' +
                                                        this.controlDisableTextColor + ' ' +
                                                        ( 100 - this.options.controlArrowsSize ) + '%,' +
                                                        this.controlDisableTextColorTrnt + ' 100%)' 
                                }).html('<div><p></p></div>');

            this.$cnrtlButtonTxtWrpr.html(this.$cnrtlButtonTxt);

            this.$cntrlButtonsBg.css({
                'width': this.options.itemSize + '%',
                'height': itemHeight + '%',
                'margin': itemMargin,
                'border-radius': this.options.itemBorderRadius + 'px',
                'background-color': this.options.controlBgColor,
                'color': this.shadowColor,
                'border-color': this.options.controlBgColor,
                'background-image': 'linear-gradient(135deg, ' + 
                                    this.controlGradientColorTrnt + ' 45%,' + 
                                    this.controlGradientColor + ' 100%)'
            });

            this.$controlPrev.add( this.$controlNext )
                             .addClass( this.options.gridStyle + '-control disable' )
                             .html( [this.$cntrlButtonsBg, this.$cnrtlButtonTxtWrpr] )
                             .css({
                                'width': this.itemInWidth + 'px',
                                'height': this.itemInHeight + 'px',
                                'font-size': this.itemInControlFontSize + 'px'
                             })
                             .children( '.' + this.options.gridStyle + '-controls-bg' )
                             .css(
                                'box-shadow', this.itemInHalfShadow + 'px ' + 
                                              this.itemInHalfShadow + 'px ' + 
                                              this.itemInShadow + 'px'
                             );             

            this.$controlPrev.find('p').text( this.options.controlPrevText );
            this.$controlNext.find('p').text( this.options.controlNextText );

            this.$elmt.append( this.$controlPrev, this.$controlNext );
        },
        // This function disable the control button
        control_btn_disable: function(button) {

            $(button).addClass('disable')
                     .children(':first')
                     .css( 'box-shadow', this.itemInHalfShadow + 'px ' + 
                                         this.itemInHalfShadow + 'px ' + 
                                         this.itemInShadow  + 'px' )
                     .next('div')
                     .find('.' + this.options.gridStyle + '-control-txt')
                     .css({
                        'color': this.options.controlDisableTextColor,
                        'background-image': 'linear-gradient(to right, ' + 
                                            this.controlDisableTextColorTrnt + ' 0%,' + 
                                            this.controlDisableTextColor   + ' ' + 
                                            this.options.controlArrowsSize + '%,' +
                                            this.controlDisableTextColor + ' ' +
                                            ( 100 - this.options.controlArrowsSize ) + '%,' +
                                            this.controlDisableTextColorTrnt + ' 100%)' 
                     });
        },
        // This function enable the control button
        control_btn_enable: function(button) {

            $(button).removeClass('disable')
                     .children(':first')
                     .css( 'box-shadow', '0px 0px 0px' )
                     .next('div')
                     .find('.' + this.options.gridStyle + '-control-txt')
                     .css({
                        'color': this.options.controlTextColor,
                        'background-image': 'linear-gradient(to right, ' + 
                                            this.controlTextColorTrnt + ' 0%,' + 
                                            this.controlTextColor   + ' ' + 
                                            this.options.controlArrowsSize + '%,' +
                                            this.controlTextColor + ' ' +
                                            ( 100 - this.options.controlArrowsSize ) + '%,' +
                                            this.controlTextColorTrnt + ' 100%)' 
                     }); 
        },
        // This function calculates the size of the carousel control buttons
        control_buttons_sizing: function( width, height, controlFontSize, shadow, halfShadow ) {

            this.$controlPrev.add( this.$controlNext ).css({
                'width': width + 'px',
                'height': height + 'px',
                'font-size': controlFontSize + 'px'
            });

            if ( this.index == 0 )
            this.$controlPrev.find('.' + this.options.gridStyle + '-controls-bg').css( 
                'box-shadow', halfShadow + 'px ' + halfShadow + 'px ' + shadow + 'px' 
            );
        },
        // This function run the carousel slides hover effects
        item_hover: function( textOnStart, textOnEnd ) {

            var self = this,
                tap = ("ontouchstart" in document.documentElement),
                textTrnstn = this.options.itemHoverSpeed;

            if ( this.options.itemHoverSpeed >= 50 )
            textTrnstn = this.options.itemHoverSpeed - 50;  

            if(!tap){
                $(this.$elmt).on('mouseenter', '.' + this.options.gridStyle + '-item-inner', function(e) {

                    e.stopPropagation();
 
                    $(this).find('.' + self.options.gridStyle + '-item-image').css({
                        'transition': 'opacity ' + self.options.itemHoverSpeed + 'ms ease',
                        'opacity': self.options.itemHoverOpacity
                    });

                    $(this).find('p').css({
                        'transform': textOnStart,
                        'opacity': '1',
                        'transition': textTrnstn + 'ms ease'
                    });

                    $(this).find('svg').css({
                        'opacity': '1',
                        'transition': 'opacity ' + textTrnstn + 'ms ease'
                    });

                }).on('mouseleave', '.' + this.options.gridStyle + '-item-inner', function() {

                    $(this).find('.' + self.options.gridStyle + '-item-image').css({
                        'opacity': '',
                        'filter': ''
                    });

                    $(this).find('p').css({
                        'transform': textOnEnd,
                        'opacity': '0'
                    });

                    $(this).find('svg').css( 'opacity', self.options.socialIconOpacity );
                });
            };
        },
        // This function calculates the maximum index of carousel slides
        max_index: function() {

            var MaxIndex = ( ( this.totalMedia - this.grid_sizing() * 3 ) / 3 ) + 1;

            if ( MaxIndex > Math.round(MaxIndex) || MaxIndex < Math.round(MaxIndex) )
            MaxIndex = Math.ceil(MaxIndex - 1);

            if( MaxIndex < 0 )
            MaxIndex = 0;    

            return MaxIndex;
        },
        // This function is intended for the carousel slide event
        slide: function() {

            var self = this;
            this.carouselIsSliding = true;

            // If the carousel has reached the maximum index
            if ( this.index == this.max_index() ) {

                this.control_btn_disable(this.$controlNext);
                this.carouselOnEnd = true;

                // Show all remaining images
                if ( this.$scrollArea.children('[data-img]').length )
                this.$scrollArea.children('[data-img]').each( function() {
                    self.item_load( this );
                });

                // Load all remaining social data
                if( this.socialAvailable && this.totalMedia > this.totalDataLoaded )
                this.get_social_data( this.totalMedia - ( this.totalDataLoaded - 1 ) );
            };

            // If the carousel does not reach the maximum index
            if ( this.index < this.max_index() ) {

                if(this.carouselOnEnd)
                this.carouselOnEnd = false;

                if( this.$controlNext.hasClass('disable') )
                this.control_btn_enable(this.$controlNext);

                // Load next non-social images
                if( this.$scrollArea.children('[data-img]').length > 0 ) {
                    var ShowFromImg = this.$scrollArea.children('[data-img]:first').index();
                    var NextShowIndex = ( ( ShowFromImg - this.grid_sizing() * 3 ) / 3 );
                    var ShowToImg = ShowFromImg + ( this.index - NextShowIndex ) * 3;

                    if ( this.index >= Math.round(NextShowIndex) && !this.socialDataLoading )
                    this.$scrollArea.children().slice( ShowFromImg, ShowToImg ).each( function() {
                        self.item_load( this );
                    });
                };

                // Loading next social data
                var LoadFromImg = this.totalDataLoaded - 1;
                var NextLoadIndex = ( ( LoadFromImg - this.grid_sizing() * 3 ) / 3 ) + 1;
                    NextLoadIndex = Math.round( NextLoadIndex );
                var LoadToImg = ( this.index - NextLoadIndex + 1 ) * 3;
                var ItemsCount = this.totalDataLoaded / 3;

                if ( ItemsCount < Math.round( ItemsCount ) )
                LoadToImg = LoadToImg - 2;

                if ( ItemsCount > Math.round( ItemsCount ) )
                LoadToImg = LoadToImg - 1;

                if( this.index >= NextLoadIndex && !this.socialDataLoading )
                this.get_social_data( LoadToImg );

                // Load more facebook data
                if ( this.index >= NextLoadIndex - this.options.gridColumns && 
                     this.currSocNetName == 'facebookPhotos' &&
                     this.isFacebookPhotosLeft && 
                     !this.socialDataLoading ||
                     this.index >= NextLoadIndex - this.options.gridColumns && 
                     this.currSocNetName == 'facebookVideos' &&
                     this.isFacebookVideosLeft && 
                     !this.socialDataLoading )
                this.get_social_data( LoadToImg );
            };

            if ( this.index == 0 )
            this.control_btn_disable(this.$controlPrev);

            if ( this.index > 0 && this.$controlPrev.hasClass('disable') )
            this.control_btn_enable(this.$controlPrev);                     

            var slide_size = this.$elmt.outerWidth() / this.grid_sizing();

            this.$scrollArea.css( 'transform', 'translate3d(-' + slide_size * this.index + 'px, -50%, 0px)' )
                            .on('transitionend', function() { 
                                self.carouselIsSliding = false;
                            }); 

            if( this.options.gridScrollSpeed == 0 )
            this.carouselIsSliding = false;
        },
        // This function slides the carousel to the next index
        slide_next: function(e) {

            if( this.carouselIsSliding || this.itemsLoading || this.socialDataLoading || this.carouselOnEnd )
            return;

            if( this.options.slideDistance == 'min' )
            this.index++;

            if( this.options.slideDistance == 'max' )
            this.index = this.index + this.options.gridColumns;

            if ( this.index > this.max_index() )
            this.index = this.max_index();

            this.slide();
        },
        // This function slides the carousel to the previous index
        slide_prev: function(e) {

            if( this.carouselIsSliding || this.index == 0 )
            return;

            if( this.options.slideDistance == 'min' )
            this.index--;

            if( this.options.slideDistance == 'max' )
            this.index = this.index - this.options.gridColumns;

            if ( this.index < 0 )
            this.index = 0;

            this.slide();
        },
        // This function determines whether a carousel is in the viewport
        is_in_viewport: function( el ) {
            var elementTop = $(el).offset().top + $(el).outerHeight() / 4;
            var elementBottom = elementTop + $(el).outerHeight() / 2;

            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();

            return elementBottom > viewportTop && elementTop < viewportBottom;
        },
        // This function is intended to control the carousel through the keyboard
        keyboard_control: function() {
            
            var self = this;

            $(document).on('keydown', function(e) {

                if($("input,textarea").is(":focus"))
                return;

                e.stopPropagation();
                e.preventDefault();
                
                if ( self.is_in_viewport( self.elmt ) && !self.lightBoxOpened && !self.keyIsDown ) {

                    if(e.which == 37)
                    self.$controlPrev.children(':first').trigger("click");                    
                    
                    if( e.which == 39 && !self.carouselOnEnd )  
                    $(self.$controlNext).children(':first').trigger("click");
                };

                if ( self.lightBoxOpened && !self.keyIsDown ) {

                    if(e.which == 37)    
                    $(self.LightBoxCntlPrev).children().trigger("click");
                    
                    if(e.which == 39)  
                    $(self.LightBoxCntlNext).children().trigger("click");
                };

                self.keyIsDown = true;
            }).on('keyup', function(e) {
                self.keyIsDown = false;
            });
        },
        // This function is executed on mouse down event
        carousel_mouse_down: function(e) {
            e.preventDefault();
            e.stopPropagation();

            this.mouseDown = true;
            this.startX = e.pageX;
            this.preventClick = false;
        },
        // This function is executed on mouse move event
        carousel_mouse_move: function(e) {

            if (!this.mouseDown)
            return;

            this.endX = e.pageX;
            this.moveX = this.$elmt.outerWidth() / this.grid_sizing() * this.index + this.startX - this.endX;
            this.translateX = this.moveX * -1;

            this.$scrollArea.css({
                'transition': '',
                'transform': 'translate3d(' + this.translateX + 'px,-50%,0px)' 
            });

            // Prevent lightbox from opening while draggin
            if ( this.moveX == 0 ) {
                this.preventClick = false;
            } else {
                this.preventClick = true;
            };
        },
        // This function is executed on mouse leave event
        carousel_mouse_leave: function(e) {

            if ( !this.mouseDown )
            return;

            this.mouseDown = false;

            this.$scrollArea.css( 
                'transition', 'transform ' + 
                              this.options.gridScrollSpeed + 
                              'ms ' + this.options.gridScrollTransitionStyle 
            );

            this.slide();
        },
        // This function is executed on touch start event
        carousel_touch_start: function(e) {
            e.stopPropagation();

            this.mouseDown = true;
            this.startX = e.originalEvent.touches[0].pageX;
            this.startY = e.originalEvent.touches[0].pageY;
            this.preventClick = false;
        },
        // This function is executed on touch move event
        carousel_touch_move: function(e) {

            e.stopPropagation();

            if (this.letItGo === null)
            this.letItGo = Math.abs(this.startY - e.originalEvent.touches[0].pageY) < Math.abs(this.startX - e.originalEvent.touches[0].pageX);

            if (this.mouseDown && this.letItGo) {
                
                e.preventDefault();

                this.$scrollArea.css( 'transition', '' );

                this.endX = e.originalEvent.touches[0].pageX;
                this.moveX = this.$elmt.outerWidth() / this.grid_sizing() * this.index + this.startX - this.endX;
                this.translateX = this.moveX * -1;

                this.$scrollArea.css( 'transform', 'translate3d(' + this.translateX + 'px,-50%,0px)' );
            };

            // Prevent the lightbox from opening during dragging
            if ( this.moveX == 0 ) {
                this.preventClick = false;
            } else {
                this.preventClick = true;
            };
        },
        // This function is intended for the carousel swipe event
        carousel_swipe: function(e) {

            var self = this;
            var slideSize = this.$elmt.outerWidth() / this.grid_sizing();
            var oldOffset = slideSize * this.index;
            var absMove = Math.abs( oldOffset - this.moveX );
            var newSwipeIndex;
            var slidesToLoad;
            var direction;

            if ( absMove > slideSize / 100 * this.options.touchThreshold && this.endX !=0 ) {

                if ( this.moveX > oldOffset ) {

                    newSwipeIndex = Math.ceil( this.moveX / slideSize );

                    if ( newSwipeIndex > this.max_index() )
                    newSwipeIndex = this.max_index();

                } else if ( this.moveX < oldOffset ) {

                    newSwipeIndex = Math.floor( this.moveX / slideSize );
                    
                    if( newSwipeIndex < 0 )
                    newSwipeIndex = 0;
                };

                this.index = newSwipeIndex;
            };

            this.$scrollArea.css( 
                'transition', 'transform ' + 
                              this.options.gridScrollSpeed + 
                              'ms ' + this.options.gridScrollTransitionStyle 
            );

            this.slide();
            
            this.moveX = 0;
            this.translateX = 0;
            this.startX = 0;
            this.endX = 0;
            this.startY = 0;
            this.letItGo = null;
            this.mouseDown = false;
        },
        // This function is intended to build and show lightbox 
        show_lightbox: function(e, el) {
            
            if ( this.preventClick || this.lightBoxOpened || this.lightBoxOnTrstn )
            return;

            this.lightBoxOnTrstn = true;
            this.ableToCloseLB = false;

            this.curLbItem = $(e.target).closest('.' + this.options.gridStyle + '-item');

            var imgSrc = this.curLbItem.find('.'+this.options.gridStyle+'-item-image').prop('style')['backgroundImage'];
                imgSrc = imgSrc.replace('url(','').replace(')','').replace(/\"/gi, "");    

            this.lightBoxItemIndex = this.curLbItem.index();  

            if( this.curLbItem.prev().hasClass('grid-adguster') )
            this.lightBoxItemIndex = this.lightBoxItemIndex - 1;

            if (imgSrc == '')
            return;
            
            this.curLightBoxImg = $('<img/>').attr('src', imgSrc);

            var imageSize = this.sizing_lightbox_image( this.curLightBoxImg );

            this.lightBoxImage.add(this.VideoFrame)
                              .html('')
                              .attr('style','')
                              .removeClass('social facebook-iframe facebook-video youtube vimeo');

            this.curLightBoxImg.removeAttr('class');
            this.curLightBoxImg.prependTo(this.lightBoxImage);

            if ( this.curLbItem.hasClass('social') )
            this.lightBoxImage.addClass('social')
                              .css('border-radius', this.options.itemBorderRadius + 'px')
                              .append( this.curLbItem.find('.caption').clone() ),
            this.curLightBoxImg.addClass('social-image');

            if ( this.curLbItem.hasClass('facebook-iframe') ) 
            this.facebookVideoCreateIframe( imgSrc, this.curLbItem.attr('video-url') ),
            this.curLightBoxImg.addClass('facebook-iframe');

            if ( this.curLbItem.hasClass('facebook-video') ) 
            this.facebookVideoCreateVideo( imgSrc, this.curLbItem.attr('video-url') ),
            this.curLightBoxImg.addClass('facebook-video');

            if ( this.curLbItem.hasClass('youtube') ) 
            this.youtubeCreateIframe( imgSrc, this.curLbItem.attr('video-id') ),
            this.curLightBoxImg.addClass('youtube');

            if ( this.curLbItem.hasClass('vimeo') ) 
            this.vimeoCreateIframe( imgSrc, this.curLbItem.attr('video-id') ),
            this.curLightBoxImg.addClass('vimeo');
            

            this.lightBoxImage.css({
                'opacity': 0,
                'visibility': 'hidden',
                'width':  imageSize[0] + 'px',
                'height': imageSize[1] + 'px',
                'top': imageSize[3] + 'px',
                'left': imageSize[4] + 'px',
                'transform': 'scale(' + this.options.lightBoxImageFadeScale + ')',
                'transition': 'transform ' + this.options.lightBoxSpeed + 'ms ' + this.options.lightBoxTransitionStyle + 
                              ', opacity ' + this.options.lightBoxSpeed + 'ms ' + this.options.lightBoxTransitionStyle +
                              ', visibility ' + this.options.lightBoxSpeed + 'ms ' + this.options.lightBoxTransitionStyle
            });

            this.closeLightBox.css({
                'opacity': 0,
                'visibility': 'hidden',
                'width':  imageSize[2] + 'px',
                'height': imageSize[2] + 'px',
                'transform': 'scale(' + this.options.lightBoxImageFadeScale + ')',
                'transition': 'transform ' + this.options.lightBoxSpeed + 'ms ' + this.options.lightBoxTransitionStyle + 
                              ', opacity ' + this.options.lightBoxSpeed + 'ms ' + this.options.lightBoxTransitionStyle +
                              ', visibility ' + this.options.lightBoxSpeed + 'ms ' + this.options.lightBoxTransitionStyle
            });

            this.closeLightBox.children('div')
                              .css({
                                    'width': this.lightbox_controls_size()[1] + '%',
                                    'height': this.lightbox_controls_size()[1] + '%'
                              });

            this.LightBoxCntlPrev.css('transform', 'translate(-25%, 0)');
            this.LightBoxCntlNext.css('transform', 'translate(25%, 0)');                  

            this.LightBoxCntlPrev.add(this.LightBoxCntlNext)
                                 .css({
                                    'opacity': 0,
                                    'visibility': 'hidden',
                                    'width':  imageSize[2] + 'px',
                                    'height': imageSize[2] * 2 + 'px',
                                    'top': imageSize[5] + 'px',
                                    'transition': 'transform ' + this.options.lightBoxSpeed + 'ms ' + this.options.lightBoxTransitionStyle +
                                                  ', opacity ' + this.options.lightBoxSpeed + 'ms ' + this.options.lightBoxTransitionStyle +
                                                  ', visibility ' + this.options.lightBoxSpeed + 'ms ' + this.options.lightBoxTransitionStyle
                                 })
                                 .children('div')
                                 .css({
                                    'width': this.lightbox_controls_size()[0] + '%',
                                    'height': this.lightbox_controls_size()[0] + '%',
                                    'background-image': 'linear-gradient(to bottom, ' +
                                                        this.controlLightBoxColorTrnt + ' 0%,' +
                                                        this.controlLightBoxColor   + ' ' +
                                                        this.options.controlArrowsSize + '%,' +
                                                        this.controlLightBoxColor + ' ' +
                                                        ( 100 - this.options.controlArrowsSize ) + '%,' +
                                                        this.controlLightBoxColorTrnt + ' 100%)'
                                 })
                                 .children('span')
                                 .css( 'width', this.lightbox_controls_size()[2] + 'px' );

            this.closeLightBox.children('div')
                              .css(
                                'background-image', 'linear-gradient(to bottom, ' +
                                                    this.controlLightBoxColorTrnt + ' 0%,' +
                                                    this.controlLightBoxColor   + ' ' +
                                                    this.options.controlArrowsSize + '%,' +
                                                    this.controlLightBoxColor + ' ' +
                                                    ( 100 - this.options.controlArrowsSize ) + '%,' +
                                                    this.controlLightBoxColorTrnt + ' 100%)'
                              )
                              .children('span')
                              .css( 'width', this.lightbox_controls_size()[2] + 'px' );

            // Run the lightbox counter               
            if(this.options.lightBoxCounter) {

                if( this.options.facebookAccessToken &&
                    this.options.facebookPhotos && 
                    this.options.lightboxCounterPlus && 
                    !this.facebookPhotosCounted ||
                    this.options.facebookAccessToken &&
                    this.options.facebookVideos && 
                    this.options.lightboxCounterPlus && 
                    !this.facebookVideosCounted ){

                    this.LightBoxCounter.text( 
                        this.lightBoxItemIndex + 1 + 
                        this.options.lightBoxCounterText + 
                        this.totalMedia +
                        ' +' );
                } else {
                    this.LightBoxCounter.text( 
                        this.lightBoxItemIndex + 1 + 
                        this.options.lightBoxCounterText + 
                        this.totalMedia );
                };

                this.LightBoxCounter.css({
                    'opacity': 0,
                    'visibility': 'hidden',
                    'color': this.controlLightBoxColor,
                    'height': imageSize[6] + 'px',
                    'transform': 'translate(0, 25%)',
                    'transition': 'transform ' + this.options.lightBoxSpeed + 'ms '+ this.options.lightBoxTransitionStyle + 
                                  ', opacity ' + this.options.lightBoxSpeed + 'ms ' + this.options.lightBoxTransitionStyle +
                                  ', visibility ' + this.options.lightBoxSpeed + 'ms ' + this.options.lightBoxTransitionStyle
                }).appendTo(this.lightBoxWrapper);
            };

            // Lightbox HTML building
            this.lightBoxOverlay.appendTo(this.lightBoxWrapper);
            this.lightBoxSpinner.appendTo(this.lightBoxWrapper);
            this.closeLightBox.appendTo(this.lightBoxWrapper);
            this.LightBoxCntlPrev.appendTo(this.lightBoxWrapper);
            this.LightBoxCntlNext.appendTo(this.lightBoxWrapper);
            this.lightBoxImage.appendTo(this.lightBoxWrapper);
            this.lightBoxWrapper.appendTo('body');

            $('body').css('overflow', 'hidden');
            
            this.lightBoxSpinner.fadeIn( this.options.lightBoxSpeed );
            
            this.lightBoxOverlay.css({
                'display': 'block',
                'background-color': this.options.lightBoxOverlayColor,
                'opacity': this.options.lightBoxOverlayOpacity,
                'transition': 'opacity ' + this.options.lightBoxSpeed + 'ms ' + this.options.lightBoxTransitionStyle
            });

            var self = this;    

            // Lightbox media building
            $(this.curLightBoxImg).on('load', function() {

                self.lightBoxSpinner.fadeOut( self.options.lightBoxSpeed );

                self.lightBoxImage.add(self.closeLightBox).css({
                    'visibility':'',
                    'transform': '',
                    'opacity': 1
                });

                self.lightBoxImage.one('transitionend', function(){

                    if ( self.curLbItem.hasClass('facebook-photo') ||
                         self.curLbItem.hasClass('facebook-iframe') || 
                         self.curLbItem.hasClass('facebook-video') )
                    self.facebookGetItemData( self.curLbItem );

                    if ( self.curLbItem.hasClass('youtube') )
                    self.youtubeGetItemData( self.curLbItem );

                    if ( self.curLbItem.hasClass('vimeo') )
                    self.vimeoGetItemData( self.curLbItem );

                    self.lightBoxOnTrstn = false;
                    self.ableToCloseLB = true;
                });

                self.LightBoxCntlPrev.add(self.LightBoxCntlNext).add(self.LightBoxCounter).css({
                    'visibility': '',
                    'opacity': 1,
                    'transform': 'translate(0, 0)'
                });
            });

            this.lightBoxOpened = true;

            // Attaching events to the lightbox control buttons
            this.LightBoxCntlNext.children().on( 'click', this.lightbox_slide_next.bind(this) );
            this.LightBoxCntlPrev.children().on( 'click', this.lightbox_slide_prev.bind(this) );
            this.lightBoxOverlay.add(this.closeLightBox)
                                .on( 'touchend mouseup pointerup MSPointerUp', this.close_lightbox.bind(this) );

            // Attaching touch events to the lightbox
            this.lightBoxImage
                .on('touchstart mousedown', this.lightbox_touch_start.bind(this))
                .on('touchmove mousemove pointermove MSPointerMove', this.lightbox_touch_move.bind(this))
                .on('touchend mouseup touchcancel mouseleave pointerup pointercancel MSPointerUp MSPointerCancel', this.lightbox_touch_end.bind(this));
        },
        // This function calculates the size of the image in lightbox
        sizing_lightbox_image: function( currentImage ) {

            var captionWidth = 0,
                captionHeight = 0;

            if ( this.curLbItem.hasClass('social') ) {

                if ( $(document).width() > 768) {
                    captionWidth = $( window ).width() * 0.25;
                    this.isMobile = false;
                } else {
                    captionHeight = 80;
                    this.isMobile = true;
                };
            };

            var tmpImage = new Image(),
                windowWidth  = $( window ).width() * this.options.lightBoxImageAspectRatio[0] - captionWidth,
                windowHeight = $( window ).height() * this.options.lightBoxImageAspectRatio[1] - captionHeight,
                counterHeight = $( window ).height() - windowHeight;
            
            tmpImage.src = $(currentImage).attr( 'src' );

            if ( this.curLbItem.hasClass('youtube') ) {
                var imageWidth = 1920,
                    imageHeight = 1080;
            } else if ( this.curLbItem.hasClass('facebook-photo') ||
                        this.curLbItem.hasClass('facebook-iframe') || 
                        this.curLbItem.hasClass('facebook-video') || 
                        this.curLbItem.hasClass('vimeo') ) {

                var imageWidth = parseInt( this.curLbItem.attr('width') ),
                    imageHeight = parseInt( this.curLbItem.attr('height') );

            } else {
                var imageWidth = tmpImage.width,
                    imageHeight = tmpImage.height;
            };

            var controlWidth = $( window ).width() - $( window ).width() * this.options.lightBoxImageAspectRatio[0];
            var cntrlTop = ( $( window ).height() - controlWidth ) / 2;

            if( imageWidth > windowWidth || imageHeight > windowHeight ){
                var ratio = imageWidth / imageHeight > windowWidth / windowHeight ? imageWidth / windowWidth : imageHeight / windowHeight;
                    imageWidth /= ratio;
                    imageHeight /= ratio;
            };

            var imageTop = ( $( window ).height() - imageHeight - captionHeight ) / 2,
                imageLeft = ( $( window ).width() - imageWidth - captionWidth) / 2;

           return [ 
                Math.round( imageWidth + captionWidth ),
                Math.round( imageHeight + captionHeight ),
                Math.round( controlWidth / 2 ),
                Math.round( imageTop ),
                Math.round( imageLeft ),
                Math.round( cntrlTop ),
                Math.round( counterHeight / 2 )
            ]   
        },
        // This function calculates the size of the lightbox control buttons
        lightbox_controls_size: function() {

            var self = this;
            var lightBoxControlSize = this.options.lightBoxControlSize,
                lightBoxCloseSize = this.options.lightBoxCloseSize,
                lightBoxControlWidth = this.options.lightBoxControlWidth;

            var breakpoints = $.map(self.options.breakPoints, function(el,i) { return i });
                breakpoints = $.grep(breakpoints, function(val) { return val >= self.$elmt.outerWidth() });

            if ( self.options.breakPoints[breakpoints[0]] )
            return [ lightBoxControlSize = self.options.breakPoints[breakpoints[0]]['lightBoxControlSize'],
                     lightBoxCloseSize = self.options.breakPoints[breakpoints[0]]['lightBoxCloseSize'],
                     lightBoxControlWidth = self.options.breakPoints[breakpoints[0]]['lightBoxControlWidth'] ];
 
            return [ lightBoxControlSize, lightBoxCloseSize, lightBoxControlWidth ];
        },
        // This function is intended for the lightbox slide event
        lightbox_slide: function( dirTo, dirFrom, nextIndex, itemsToLoad ) {

            var self = this;

            this.lightBoxOnTrstn = true;

            this.curLbItem = $('.' + this.options.gridStyle +'-item').eq(nextIndex);

            this.lightBoxImage.css({
                'transform': 'translate(' + dirTo + ',0)',
                'opacity': 0,
                'visibility': 'hidden'
            });

            // Show next images if they exist
            if( this.curLbItem.length )
            this.lightBoxImage.one('transitionend', function(){
                self.lightBoxSpinner.delay( self.options.lightBoxSpeed ).show();
                self.lightbox_load_next( self.curLbItem, dirFrom, nextIndex, itemsToLoad );
            });

            // Load new social data
            if( !this.curLbItem.length ||
                nextIndex + 1 == this.totalMedia && this.currSocNetName == 'facebookPhotos' && this.isFacebookPhotosLeft ||
                nextIndex + 1 == this.totalMedia && this.currSocNetName == 'facebookVideos' && this.isFacebookVideosLeft) {

                var ItemsCount = this.totalDataLoaded / 3;

                if ( ItemsCount < Math.round( ItemsCount ) )
                itemsToLoad = itemsToLoad - 2;

                if ( ItemsCount > Math.round( ItemsCount ) )
                itemsToLoad = itemsToLoad - 1;

                if( this.totalDataLoaded + itemsToLoad >= this.totalMedia )
                itemsToLoad = this.totalMedia - this.totalDataLoaded;

                this.get_social_data( itemsToLoad );

                this.lightBoxImage.one('transitionend', function(){

                    self.lightBoxSpinner.delay( self.options.lightBoxSpeed ).show();
                    self.lightBoxLoading = true;

                    var waitDataLoad = setInterval(function() {
                        self.curLbItem = self.$scrollArea.children().eq( nextIndex );
                        if ( self.curLbItem.length ) {
                            self.lightbox_load_next( self.curLbItem, dirFrom, nextIndex );
                            clearInterval(waitDataLoad);
                        };
                    }, 200);
                });
            };

            // Update the lightbox counter
            if( this.options.lightBoxCounter ) {

                if( this.options.facebookAccessToken &&
                    this.options.facebookPhotos && 
                    this.options.lightboxCounterPlus && 
                    !this.facebookPhotosCounted ||
                    this.options.facebookAccessToken &&
                    this.options.facebookVideos && 
                    this.options.lightboxCounterPlus && 
                    !this.facebookVideosCounted ){

                    this.LightBoxCounter
                        .css({ 'opacity': 0, 
                            'transform': 
                            'scale(0.95)' 
                        })
                        .on('transitionend', function(){
                            $(this).text( nextIndex + 1 + self.options.lightBoxCounterText + self.totalMedia + ' +')
                                   .css({
                                        'opacity': 1,
                                        'transform': 'scale(1)' 
                                    });
                        });
                } else {

                    this.LightBoxCounter
                        .css({ 'opacity': 0, 
                            'transform': 
                            'scale(0.95)' 
                        })
                        .on('transitionend', function(){
                            $(this).text( nextIndex + 1 + self.options.lightBoxCounterText + self.totalMedia )
                                   .css({
                                        'opacity': 1,
                                        'transform': 'scale(1)' 
                                    });
                        });
                }
            };
        },
        // This function runs to upload the next image in lightbox
        lightbox_load_next: function( nextItem, dirFrom, nextIndex, itemsToLoad ) {

            var self = this;

            if ( nextItem.is('[data-img]') ) {

                var imgSrc = nextItem.attr('data-img');

                this.items.slice( nextIndex, nextIndex + itemsToLoad ).each( function() { 
                    self.item_load( this ); 
                });

            } else {
                var imgSrc = nextItem.find('.'+this.options.gridStyle+'-item-image').prop('style')['backgroundImage'];
                    imgSrc = imgSrc.replace('url(','').replace(')','').replace(/\"/gi, "");
            };

            this.lightBoxImage.add(this.VideoFrame)
                              .html('')
                              .attr('style','')
                              .removeClass('social facebook-iframe facebook-video youtube vimeo');

            this.curLightBoxImg.removeAttr('class');

            this.curLightBoxImg = $('<img/>').attr('src', imgSrc);
            var curLightBoxImgSize = this.sizing_lightbox_image( this.curLightBoxImg );

            this.lightBoxImage.css({
                'opacity': 0,
                'visibility': 'hidden',
                'width':  curLightBoxImgSize[0] + 'px',
                'height': curLightBoxImgSize[1] + 'px',
                'top': curLightBoxImgSize[3] + 'px',
                'left': curLightBoxImgSize[4] + 'px',
                'transform': 'translate(' + dirFrom + '%,0)',
                'transition': 'transform ' + this.options.lightBoxSpeed + 'ms ' + this.options.lightBoxTransitionStyle + 
                              ', opacity ' + this.options.lightBoxSpeed + 'ms ' + this.options.lightBoxTransitionStyle +
                              ', visibility ' + this.options.lightBoxSpeed + 'ms ' + this.options.lightBoxTransitionStyle
            });

            if ( nextItem.hasClass('social') )
            this.lightBoxImage.addClass('social')
                              .css('border-radius', this.options.itemBorderRadius + 'px')
                              .append( nextItem.find('.caption').clone() ),
            this.curLightBoxImg.addClass('social-image');

            if ( nextItem.hasClass('facebook-iframe') ) 
            this.facebookVideoCreateIframe( imgSrc, nextItem.attr('video-url') ),
            this.curLightBoxImg.addClass('facebook-iframe');

            if ( nextItem.hasClass('facebook-video') ) 
            this.facebookVideoCreateVideo( imgSrc, nextItem.attr('video-url') ),
            this.curLightBoxImg.addClass('facebook-video');

            if ( nextItem.hasClass('youtube') )
            this.youtubeCreateIframe( imgSrc, nextItem.attr('video-id') ),
            this.curLightBoxImg.addClass('youtube');

            if ( nextItem.hasClass('vimeo') )
            this.vimeoCreateIframe( imgSrc, nextItem.attr('video-id') ),
            this.curLightBoxImg.addClass('vimeo');

            this.curLightBoxImg.prependTo(this.lightBoxImage);
            this.lightBoxImage.appendTo(this.lightBoxWrapper);

            this.lightBoxLoading = false;

            this.curLightBoxImg.on('load', function() {

                var waitImgLoad = setInterval(function() {
                       
                    if ( !self.lightBoxLoading ) {
                            
                        self.lightBoxImage.css({
                            'visibility':'',
                            'transform': 'translate(0,0)',
                            'opacity': 1
                        })
                        .one('transitionend', function(){

                            if ( nextItem.hasClass('facebook-photo') ||
                                 nextItem.hasClass('facebook-iframe') || 
                                 nextItem.hasClass('facebook-video') )
                            self.facebookGetItemData( nextItem );

                            if ( nextItem.hasClass('youtube') )
                            self.youtubeGetItemData( nextItem );

                            if ( nextItem.hasClass('vimeo') )
                            self.vimeoGetItemData( nextItem );

                            self.lightBoxOnTrstn = false;
                        });

                        clearInterval(waitImgLoad);
                    };
                }, 200);

                self.lightBoxSpinner.hide();
            }).on('error', function(){

                self.lightBoxImage.css('background-color', '#000000');

                if ( !self.lightBoxLoading ) {
                            
                    self.lightBoxImage.css({
                        'visibility':'',
                        'transform': 'translate(0,0)',
                        'opacity': 1
                    })
                    .one('transitionend', function(){

                        if ( nextItem.hasClass('facebook-photo') ||
                             nextItem.hasClass('facebook-iframe') || 
                             nextItem.hasClass('facebook-video') )
                        self.facebookGetItemData( nextItem );

                        if ( nextItem.hasClass('youtube') )
                        self.youtubeGetItemData( nextItem );

                        if ( nextItem.hasClass('vimeo') )
                        self.vimeoGetItemData( nextItem );

                        self.lightBoxOnTrstn = false;
                    });
                };
            });
        },
        // This function is intended for the 'touch start' event of the lightbox
        lightbox_touch_start: function(e) {

            e.preventDefault();
            e.stopPropagation();

            this.lightBoxMouseDown = true;
            this.lightBoxStartX = e.originalEvent.pageX || e.originalEvent.touches[ 0 ].pageX;
            this.lightBoxStartY = e.originalEvent.pageY || e.originalEvent.touches[ 0 ].pageY;
        },
        // This function is intended for the 'touch move' event of the lightbox
        lightbox_touch_move: function(e) {

            if (!this.lightBoxMouseDown)
            return;

            e.stopPropagation();
            e.preventDefault();

            this.lightBoxEndX = e.originalEvent.pageX || e.originalEvent.touches[ 0 ].pageX;
            this.lightBoxMoveX = this.lightBoxStartX - this.lightBoxEndX;
            this.lightBoxTranslateX = this.lightBoxMoveX * -1;

            this.lightBoxImage.css({
                'transition': '',
                'transform': 'translate(' + this.lightBoxTranslateX + 'px,0)' 
            });
        },
        // This function is intended for the 'touch end' event of the lightbox
        lightbox_touch_end: function(e) {

            if (!this.lightBoxMouseDown)
            return;

            var ImageXdistance = e.originalEvent.pageX || e.originalEvent.touches[ 0 ].pageX,
                ImageXdistance = Math.abs(this.lightBoxStartX - ImageXdistance);

            var ImageYdistance = e.originalEvent.pageY || e.originalEvent.touches[ 0 ].pageY,
                ImageYdistance = Math.abs(this.lightBoxStartY - ImageYdistance);

            if ( Math.ceil(ImageYdistance) <= Math.ceil(ImageXdistance) )
            this.lightbox_swipe();

            if ( Math.ceil(ImageYdistance) > Math.ceil(ImageXdistance) )
            this.close_lightbox(e);

            // Clear variables
            this.lightBoxMoveX = 0;
            this.lightBoxTranslateX = 0;
            this.lightBoxStartX = 0;
            this.lightBoxEndX = 0;
            this.lightBoxStartY = 0;
            this.lightBoxMouseDown = false;
        },
        // This function is intended for the 'swipe' event of the lightbox
        lightbox_swipe: function() {

            var TransitionDistance = this.lightBoxImage.outerWidth() / 100 * this.options.lightBoxTransitionDistance,
                absMoveX = Math.abs( this.lightBoxTranslateX );

            this.lightBoxImage.css( 'transition', this.options.lightBoxSpeed + 'ms ' + this.options.lightBoxTransitionStyle );

            if( absMoveX <= TransitionDistance ) {
                
                this.lightBoxImage.css( 'transform', 'translate(0,0)' );

            } else {

                if ( this.lightBoxTranslateX < 0 ) {

                    if ( this.lightBoxItemIndex + 1 < this.totalMedia ) {   
                        this.lightBoxItemIndex++;
                    } else {   
                        this.lightBoxItemIndex = 0;
                    };

                    if( this.options.slideDistance == 'min' )
                    var itemsToLoad = 3;

                    if( this.options.slideDistance == 'max' )
                    var itemsToLoad = this.options.gridColumns * 3;

                    this.lightbox_slide( 
                        - (absMoveX + TransitionDistance) + 'px', 
                        this.options.lightBoxTransitionDistance, 
                        this.lightBoxItemIndex,
                        itemsToLoad
                    );
                };

                if ( this.lightBoxTranslateX >= 0 ) {

                    if ( this.lightBoxItemIndex > 0 ) {
                        
                        this.lightBoxItemIndex--;

                        this.lightbox_slide(
                            absMoveX + TransitionDistance + 'px', 
                            - this.options.lightBoxTransitionDistance, 
                            this.lightBoxItemIndex
                        );

                    } else {

                        if( this.totalDataLoaded >= this.totalMedia )
                        this.lightBoxItemIndex = this.totalMedia - 1,
                        this.lightbox_slide(
                            absMoveX + TransitionDistance + 'px', 
                            - this.options.lightBoxTransitionDistance, 
                            this.lightBoxItemIndex
                        );    
                        
                        if( this.totalDataLoaded < this.totalMedia )
                        this.lightBoxItemIndex = 0,
                        this.lightBoxImage.css( 'transform', 'translate(0,0)' );
                    };  
                };
            };
        },
        // This function slides to the next image in the lightbox
        lightbox_slide_next: function() {

            if ( this.lightBoxOnTrstn || this.itemsLoading || this.lightBoxLoading )
            return;

            if ( this.lightBoxItemIndex + 1 < this.totalMedia ) {   
                this.lightBoxItemIndex++;
            } else {   
                this.lightBoxItemIndex = 0;
            };

            var itemsToLoad;

            if( this.options.slideDistance == 'min' )
            itemsToLoad = 3;

            if( this.options.slideDistance == 'max' )
            itemsToLoad = this.options.gridColumns * 3;

            this.lightbox_slide( 
                - this.options.lightBoxTransitionDistance + '%', 
                this.options.lightBoxTransitionDistance, 
                this.lightBoxItemIndex,
                itemsToLoad
            );
        },
        // This function slides to the previous image in the lightbox
        lightbox_slide_prev: function() {

            if ( this.lightBoxOnTrstn || this.lightBoxLoading )
            return;

            if ( this.lightBoxItemIndex > 0 ) {
                this.lightBoxItemIndex--;
            } else {
                
                if ( this.totalDataLoaded < this.totalMedia ||
                     this.options.facebookAccessToken &&
                     this.options.facebookPhotos && 
                     !this.facebookPhotosCounted ||
                     this.options.facebookAccessToken &&
                     this.options.facebookVideos && 
                     !this.facebookVideosCounted )
                return;

                this.lightBoxItemIndex = this.totalMedia - 1;
            };
 
            this.lightbox_slide(
                this.options.lightBoxTransitionDistance + '%', 
                -this.options.lightBoxTransitionDistance, 
                this.lightBoxItemIndex
            );
        },
        // This function is intended to close lightbox
        close_lightbox: function(e) {

            if( !this.ableToCloseLB )
            return;

            this.lightBoxOnTrstn = true;

            e.preventDefault();
            e.stopPropagation();

            this.lightBoxImage.add(this.closeLightBox).css({
                'opacity': 0,
                'visibility': 'hidden',
                'transform': 'scale(' + this.options.lightBoxImageFadeScale + ')',
                'transition': this.options.lightBoxSpeed + 'ms ease-in-out'
            });

            this.LightBoxCntlPrev.css('transform', 'translate(-25%, 0)');
            this.LightBoxCntlNext.css('transform', 'translate(25%, 0)'); 

            this.LightBoxCntlPrev.add(this.LightBoxCntlNext).css({
                'opacity': 0,
                'visibility': 'hidden'
            });

            if( this.options.lightBoxCounter )
            this.LightBoxCounter.css({
                'opacity': 0,
                'visibility': 'hidden',
                'transform': 'translate(0, 25%)'
            });

            this.lightBoxOverlay.css('opacity', 0);

            var self = this;

            this.lightBoxImage.on('transitionend', function(){
                self.lightBoxOpened = false;
                self.lightBoxOnTrstn = false;
                self.lightBoxWrapper.remove();
                $('body').css('overflow', '');
            });

            this.carouselIsSliding = false;
        },
        // This is a global function to get data from social networks
        get_social_data: function( results ){

            this.currSocNet = 0;

            this[ this.socialNetworks[this.currSocNet] + 'GetData' ]( 
                this[ this.socialNetworks[this.currSocNet] + 'Request' ], 
                this.options[ this.socialNetworks[this.currSocNet] + 'Query' ], 
                this[ this.socialNetworks[this.currSocNet] + 'NextPage' ], 
                results 
            );
        },
        // This function is running when the data from the social network is successfully downloaded
        get_social_data_success: function( NextSocNet, results, loaded ) {

            var self = this;

            var ShowFromImg = this.$scrollArea.children('[data-img]:first').index();
            var ShowToImg = ShowFromImg + results;

            if ( !this.lightBoxOpened )
            this.$scrollArea.children().slice( ShowFromImg, ShowToImg ).each( function() {
                self.item_load( this );
            });

            this.socialDataLoading = false;

            if ( this.totalMedia >= this.grid_sizing() * 3 && !this.carouselOnEnd )
            this.control_btn_enable( this.$controlNext );

            // Getting items count in the next social network
            if ( NextSocNet && !this[NextSocNet + 'Total'] )
            this[ NextSocNet + 'GetMediaCount' ]( this[NextSocNet+'Request'], this.options[NextSocNet+'Query'] );

            // Getting data from the next social network if all data of current network has been dowloaded
            if ( NextSocNet && loaded < results )
            this[ NextSocNet + 'GetData' ]( 
                this[ NextSocNet + 'Request' ], 
                this.options[ NextSocNet + 'Query' ], 
                this[ NextSocNet + 'NextPage' ], 
                results - loaded
            );

            // Adjusting the last column of the carousel when downloading all social data
            if ( !NextSocNet && 
                 this.totalDataLoaded == this.totalMedia && 
                 this.totalMedia / 3 < Math.round( this.totalMedia / 3 )
               )
            this.adjustLastColumn();
        },
        // This function is running if the data loading from the social network failed
        get_social_data_error: function( CurrSocNet, NextSocNet, results ) { 

            if( !this[ CurrSocNet + 'Total' ] )
            this[ CurrSocNet + 'Total' ] = 0;

            this.totalMedia = this.totalMedia - ( this[ CurrSocNet + 'Total' ] - this[ CurrSocNet + 'DataLoaded' ] );

            if ( NextSocNet )
            this[ NextSocNet + 'GetData' ]( 
                this[ NextSocNet + 'Request' ], 
                this.options[ NextSocNet + 'Query' ], 
                this[ NextSocNet + 'NextPage' ], 
                results
            );

            if ( !NextSocNet )
            this.socialDataLoading = false;
        },
        // This function is running when all social network data is downloaded
        get_social_data_end: function( NextSocNet, results ) {

            this[ NextSocNet + 'GetData' ]( 
                this[ NextSocNet + 'Request' ], 
                this.options[ NextSocNet + 'Query' ], 
                this[ NextSocNet + 'NextPage' ], 
                results 
            );
        },
        // This function is intended to getting the count of Facebook photos
        facebookPhotosGetMediaCount: function() {

            if ( this.totalMedia < this.grid_sizing() * 3 )
            return;

            var self = this;

            var DataLimit = this.options.gridColumns * 3;

            $.ajax({
                type: "GET",
                dataType: "jsonp",
                cache: false,
                crossDomain: true,
                url: 'https://graph.facebook.com/'+this.options.facebookAlbumID+'?fields=photos.type(uploaded).limit(' + 
                     DataLimit + '){album{type}}&access_token=' + 
                     this.options.facebookAccessToken,
                success: function(data) {

                    // Calculating total media count
                    if( data.photos )
                    self.facebookPhotosTotal = data.photos.data.length,
                    self.totalMedia = self.totalMedia + data.photos.data.length,
                    self.facebookPhotosPrecount = data.photos.data.length;
           
                    // Excluding Cover and Profile pictures
                    if ( data.photos && self.options.hideFacebookCoverPic || data.photos && self.options.hideFacebookProfilePic)
                    $(data.photos.data).each( function(i) {
                        if (self.options.hideFacebookCoverPic && this.album.type == 'cover' || self.options.hideFacebookProfilePic && this.album.type == 'profile') {
                            self.facebookPhotosTotal--;
                            self.totalMedia--;
                            self.facebookPhotosPrecount--;
                            return;
                        };
                    });

                    var NextSocNet = self.socialNetworks.indexOf('facebookPhotos') + 1;

                    self.get_social_data_success( self.socialNetworks[ NextSocNet ] );

                    if( !data.photos || !data.photos.paging.next )
                    self.facebookPhotosCounted = true;

                    if( !data.photos )
                    self.facebookPhotosTotal = 0;
                }
            });    
        },
        // This function is intended to getting Facebook photos
        facebookPhotosGetData: function(request, query, nextpage, results) {

            // Find out if another social network is set
            var CurrSocNet = this.socialNetworks[ this.currSocNet ];
            this.currSocNet++;
            if ( this.socialNetworks[ this.currSocNet ] )
            var NextSocNet = this.socialNetworks[ this.currSocNet ];
            this.currSocNetName = 'facebookPhotos';

            // Variables to create a layout
            var self = this,
                itemHeight = this.options.itemSize,
                itemMargin = this.itemMagrin + '%',
                gradientAngle = 'to bottom',
                tltX = 100 - itemHeight,
                tltY = tltX,
                Media = $('<div>').addClass('facebook-photo'),
                Caption = $('<div>').addClass('caption'),
                TopData =$().removeClass(),
                TopBanner = $().addClass(),
                AuthorAndLink = $('<div>').addClass('caption-author-and-link'),
                AuthorLink = $('<div>').addClass('caption-author'),
                AuthorPhoto = $().addClass(),
                AuthorName = $('<span>').addClass('caption-author-name'),
                MediaLink = $('<a>').addClass('media-link facebook'),
                StatisticAndTime = $('<div>').addClass('facebook caption-statistic-and-time'),
                StatisticCounters = $('<div>').addClass('facebook statistic-counters'),
                CommentCounter = $('<div>').addClass('comments-counter'),
                ReactionsCounter = $('<div>').addClass('reactions-counter'),
                LikesCounter = $('<div>').addClass('likes-counter'),
                LoveCounter = $('<div>').addClass('love-counter'),
                WowCounter = $('<div>').addClass('wow-counter'),
                HahaCounter = $('<div>').addClass('haha-counter'),
                SadCounter = $('<div>').addClass('sad-counter'),
                AngryCounter = $('<div>').addClass('angry-counter'),
                PublishedTime = $().addClass(),
                FacebookIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg'),
                FacebookIconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path'),
                DescAndComments = $('<div>').addClass('description-and-comments'),
                MediaDesc = $('<div>').addClass('media-description');

            if (this.options.gridStyle == 'tile')
            itemHeight = this.tileHeight,  
            itemMargin = 0,
            gradientAngle = '135deg',
            tltY = 0;

            // Creation of the Facebook icon
            FacebookIcon.setAttribute('class','facebook');
            FacebookIcon.setAttribute('viewBox','-180 -180 400 400');
            FacebookIcon.setAttribute('preserveAspectRatio','xMidYMax slice');
            FacebookIcon.setAttribute('width','100%');
            FacebookIconPath.setAttribute('d','M198-160h-356c0,0-22,0.016-22,19.8v320.4c0,19.8,22,19.8,22,'+
                                              '19.8H34V61.4h-52V5.6h52V-34 c3.666-78.749,71.999-74.699,124-70.2v48.'+
                                              '6c-32.333,1.8-62-7.65-62,26.1V5.6h60l-8,55.8H96V200h102c0,0,22,0,22-19.'+
                                              '8v-320.4 C220-160.002,198-160,198-160z');
            FacebookIcon.appendChild(FacebookIconPath);

            // Calculate the number of images for a query
            var DataLimit = this.options.gridColumns * 3 * 2;

            // Download data from Facebook if it is still available
            if( this.facebookPhotosTotal == null || this.isFacebookPhotosLeft )
            this.socialDataLoading = true,
            $.ajax({
                type: "GET",
                dataType: "jsonp",
                cache: false,
                crossDomain: true,
                url: 'https://graph.facebook.com/' + this.options.facebookAlbumID +'?fields=photos.type(uploaded).limit(' + 
                     DataLimit + ')' +
                     nextpage + '{link,images,name,album{type},created_time,' +
                     'comments.limit(0)' + 
              '},link,picture{url},name' +
                     '&access_token=' + this.options.facebookAccessToken,

                success: function(data) {

                    // If something went wrong, like a Rate Limit
                    if (data.error) {
                        self.get_social_data_error( CurrSocNet, NextSocNet, results );
                        console.log('Facebook error', data.error.message);
                        return;
                    };

                    // If there is no photos
                    if(!data.photos) {
                        self.get_social_data_success( NextSocNet, results, 0 );
                        self.facebookPhotosTotal = 0;
                        self.isFacebookPhotosLeft = false;
                        self.facebookPhotosCounted = true;
                        return;
                    };

                    // Determine where to start the next download
                    if( data.photos.paging.next ) {
                        self.facebookPhotosNextPage = '.after(' + data.photos.paging.cursors.after + ')';
                        self.isFacebookPhotosLeft = true;
                    } else {
                        self.facebookPhotosNextPage = '';
                        self.isFacebookPhotosLeft = false;
                        self.facebookPhotosCounted = true;
                    };

                    // Calculating the total number of images
                    self.facebookPhotosTotal = self.facebookPhotosTotal - self.facebookPhotosPrecount + data.photos.data.length;
                    self.totalMedia = self.totalMedia - self.facebookPhotosPrecount + data.photos.data.length;
                    self.facebookPhotosPrecount = 0;

                    self.itemsLoadCnt = data.photos.data.length;

                    // Slides creation 
                    $(data.photos.data).each( function(i) {

                        // Excluding Cover and Profile pictures
                        if (self.options.hideFacebookCoverPic && this.album.type == 'cover' || self.options.hideFacebookProfilePic && this.album.type == 'profile') {
                            self.facebookPhotosTotal--;
                            self.totalMedia--;
                            self.itemsLoadCnt--;
                            return;
                        };

                        self.totalDataLoaded++;
                        self.facebookPhotosDataLoaded++;

                        var ThumbPic = this.images[0].source,
                            ThumbWidth = this.images[0].width,
                            ThumbHeight = this.images[0].height,
                            TotalReactions = 0;

                        if( this.images[3] && this.images[3].height > 250 )
                        ThumbPic = this.images[3].source,
                        ThumbWidth = this.images[3].width,
                        ThumbHeight = this.images[3].height;

                        // Adding cover photo if exist
                        if( self.facebookProfileCoverPhoto )
                        TopBanner.html('<div>')
                                 .children()
                                 .css( 'background-image', 'url(' + self.facebookProfileCoverPhoto + ')' );

                        AuthorPhoto.html('<img>')
                                   .children()
                                   .attr('src', data.picture.data.url);

                        AuthorName.text(data.name);
                        AuthorLink.html(AuthorName);

                        MediaLink.attr({ 'href': this.link, 'target': '_blank' })
                                 .text(self.options.lightBoxSocialLinkText+' Facebook');

                        AuthorAndLink.html([AuthorPhoto, AuthorLink, MediaLink]);
                        
                        TopData.html([TopBanner, AuthorAndLink]);

                        CommentCounter.html(self.CommentsIcon)
                                      .append('<span>')
                                      .children('span')
                                      .text(this.comments.summary.total_count);

                        // Clear reactions
                        ReactionsCounter.html('');

                        // Reactions to the image
                        if( this.reactions_like.summary.total_count > 0 )
                        TotalReactions = TotalReactions + this.reactions_like.summary.total_count,
                        ReactionsCounter.append(LikesCounter);

                        if( this.reactions_love.summary.total_count > 0 )
                        TotalReactions = TotalReactions + this.reactions_love.summary.total_count,
                        ReactionsCounter.append(LoveCounter);

                        if( this.reactions_wow.summary.total_count > 0 )
                        TotalReactions = TotalReactions + this.reactions_wow.summary.total_count,
                        ReactionsCounter.append(WowCounter);

                        if( this.reactions_haha.summary.total_count > 0 )
                        TotalReactions = TotalReactions + this.reactions_haha.summary.total_count,
                        ReactionsCounter.append(HahaCounter);

                        if( this.reactions_sad.summary.total_count > 0 )
                        TotalReactions = TotalReactions + this.reactions_sad.summary.total_count,
                        ReactionsCounter.append(SadCounter);

                        if( this.reactions_angry.summary.total_count > 0 )
                        TotalReactions = TotalReactions + this.reactions_angry.summary.total_count,
                        ReactionsCounter.append(AngryCounter);

                        if ( TotalReactions > 0 )
                        ReactionsCounter.append('<span>').find('span').text(TotalReactions);

                        StatisticCounters.html([CommentCounter, ReactionsCounter]);

                        var CreatedTime = this.created_time.replace(/\+/g, '.');
                        PublishedTime.attr('date', CreatedTime).html( self.timeElapsed(CreatedTime) );

                        StatisticAndTime.html([StatisticCounters, PublishedTime]);

                        DescAndComments.html(StatisticAndTime); 

                        if( this.name && !self.isMobile )
                        MediaDesc.html( self.matchLinks( this.name ) ).insertAfter(StatisticAndTime); 

                        if( self.isMobile )
                        DescAndComments.html(StatisticAndTime);           

                        Caption.html([TopData, DescAndComments]);

                        Media.html(Caption)
                             .attr({
                                'width': ThumbWidth,
                                'height': ThumbHeight,
                                'media-id': this.id,
                                'data-img': ThumbPic
                             });

                        if (self.options.socialIcon)
                        Media.append(FacebookIcon);
         
                        self.grid_item( Media, itemHeight, itemMargin, gradientAngle, tltX, tltY );

                        Media.clone().appendTo(self.$scrollArea);
                    });

                    self.get_social_data_success( NextSocNet, results, self.itemsLoadCnt );
                },
                error: function(data) {

                    console.log(data);
                    this.get_social_data_error( CurrSocNet, NextSocNet, results );
                }
            });

            // If all Facebook photos are downloaded
            if( NextSocNet && !this.isFacebookPhotosLeft )
            this.get_social_data_end( NextSocNet, results );
        },
        // This function is intended to getting the count of Facebook videos
        facebookVideosGetMediaCount: function() {
            
            if ( this.totalMedia < this.grid_sizing() * 3 )
            return;

            var self = this;

            // Calculating request count
            var DataLimit = this.options.gridColumns * 3;

            $.ajax({
                type: "GET",
                dataType: "jsonp",
                cache: false,
                crossDomain: true,
                url: 'https://graph.facebook.com/me?fields=videos.type(uploaded).limit(' + 
                     DataLimit + ')&access_token=' + 
                     this.options.facebookAccessToken,
                success: function(data) {

                    // Calculating total media count
                    if( data.videos )
                    self.facebookVideosTotal = data.videos.data.length,
                    self.totalMedia = self.totalMedia + data.videos.data.length,
                    self.facebookVideosPrecount = data.videos.data.length;

                    var NextSocNet = self.socialNetworks.indexOf('facebookVideos') + 1;

                    self.get_social_data_success( self.socialNetworks[ NextSocNet ] );

                    if( !data.videos || !data.videos.paging.next )
                    self.facebookPhotosCounted = true;

                    if( !data.videos )
                    self.facebookVideosTotal = 0;
                }
            });    
        },
        // This function is intended to getting Facebook videos
        facebookVideosGetData: function(request, query, nextpage, results) {

            // Find out if another social network is set
            var CurrSocNet = this.socialNetworks[ this.currSocNet ];
            this.currSocNet++;
            if ( this.socialNetworks[ this.currSocNet ] )
            var NextSocNet = this.socialNetworks[ this.currSocNet ];
            this.currSocNetName = 'facebookVideos';

            // Variables to create a layout
            var self = this,
                itemHeight = this.options.itemSize,
                itemMargin = this.itemMagrin + '%',
                gradientAngle = 'to bottom',
                tltX = 100 - itemHeight,
                tltY = tltX,
                Media = $('<div>'),
                Caption = $('<div>').addClass('caption'),
                TopData = $('<div>').addClass('social-top-data facebook'),
                TopBanner = $('<div>').addClass('profile-banner'),
                AuthorAndLink = $('<div>').addClass('caption-author-and-link'),
                AuthorLink = $('<div>').addClass('caption-author'),
                AuthorPhoto = $('<div>').addClass('caption-author-photo'),
                AuthorName = $('<span>').addClass('caption-author-name'),
                MediaLink = $('<a>').addClass('media-link facebook'),
                StatisticAndTime = $('<div>').addClass('caption-statistic-and-time'),
                StatisticCounters = $('<div>').addClass('facebook statistic-counters'),
                CommentCounter = $().removeClass(),
                ReactionsCounter = $('<div>').addClass('reactions-counter'),
                LikesCounter = $('<div>').addClass('likes-counter'),
                LoveCounter = $('<div>').addClass('love-counter'),
                WowCounter = $('<div>').addClass('wow-counter'),
                HahaCounter = $('<div>').addClass('haha-counter'),
                SadCounter = $('<div>').addClass('sad-counter'),
                AngryCounter = $('<div>').addClass('angry-counter'),
                PublishedTime = $('<span>').addClass('post-published-time'),
                FacebookIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg'),
                FacebookIconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path'),
                DescAndComments = $('<div>').addClass('description-and-comments'),
                MediaDesc = $('<div>').addClass('media-description');

            if (this.options.gridStyle == 'tile')
            itemHeight = this.tileHeight,  
            itemMargin = 0,
            gradientAngle = '135deg',
            tltY = 0;

             // Creation of the Facebook icon
            FacebookIcon.setAttribute('class','facebook');
            FacebookIcon.setAttribute('viewBox','-180 -180 400 400');
            FacebookIcon.setAttribute('preserveAspectRatio','xMidYMax slice');
            FacebookIcon.setAttribute('width','100%');
            FacebookIconPath.setAttribute('d','M198-160h-356c0,0-22,0.016-22,19.8v320.4c0,19.8,22,19.8,22,'+
                                              '19.8H34V61.4h-52V5.6h52V-34 c3.666-78.749,71.999-74.699,124-70.2v48.'+
                                              '6c-32.333,1.8-62-7.65-62,26.1V5.6h60l-8,55.8H96V200h102c0,0,22,0,22-19.'+
                                              '8v-320.4 C220-160.002,198-160,198-160z');
            FacebookIcon.appendChild(FacebookIconPath);

            // Calculate the number of images for a query
            var DataLimit = this.options.gridColumns * 3;

            // Download data from Facebook if it is still available
            if( this.facebookVideosTotal == null || this.isFacebookVideosLeft )
            this.socialDataLoading = true,
            $.ajax({
                type: "GET",
                dataType: "jsonp",
                cache: false,
                crossDomain: true,
                url: 'https://graph.facebook.com/me?fields=videos.type(uploaded).limit(' + 
                     DataLimit + ')'+
                     nextpage + '{description,format,created_time,permalink_url,privacy,source,' +
                     'thumbnails.limit(0){height,width,uri},' +
                     'comments.limit(0).summary(total_count),' + 
                     'reactions.type(LIKE).limit(0).summary(total_count).as(reactions_like),' +
                     'reactions.type(LOVE).limit(0).summary(total_count).as(reactions_love),'+
                     'reactions.type(WOW).limit(0).summary(total_count).as(reactions_wow),'+
                     'reactions.type(HAHA).limit(0).summary(total_count).as(reactions_haha),'+
                     'reactions.type(SAD).limit(0).summary(total_count).as(reactions_sad),'+
                     'reactions.type(ANGRY).limit(0).summary(total_count).as(reactions_angry)'+
                     '},link,picture{url},name' +
                     '&access_token=' + this.options.facebookAccessToken,

                success: function(data) {

                    // If something went wrong, like a Rate Limit
                    if (data.error) {
                        self.get_social_data_error( CurrSocNet, NextSocNet, results );
                        console.log('Facebook error', data.error.message);
                        return;
                    };

                    // If there is no videos
                    if(!data.videos) {
                        self.get_social_data_success( NextSocNet, results, 0 );
                        self.facebookVideosTotal = 0;
                        self.isFacebookVideosLeft = false;
                        self.facebookVideosCounted = true;
                        return;
                    };

                    // Determine where to start the next download
                    if( data.videos.paging.next ) {
                        self.facebookVideosNextPage = '.after(' + data.videos.paging.cursors.after + ')';
                        self.isFacebookVideosLeft = true;
                    } else {
                        self.facebookVideosNextPage = '';
                        self.isFacebookVideosLeft = false;
                        self.facebookVideosCounted = true;
                    };

                    // Calculating the total number of videos
                    self.facebookVideosTotal = self.facebookVideosTotal - self.facebookVideosPrecount + data.videos.data.length;
                    self.totalMedia = self.totalMedia - self.facebookVideosPrecount + data.videos.data.length;
                    self.facebookVideosPrecount = 0;

                    self.itemsLoadCnt = data.videos.data.length;

                    // Slides creation
                    $(data.videos.data).each( function(i) {

                        self.totalDataLoaded++;
                        self.facebookVideosDataLoaded++;

                        if( this.privacy.value == 'EVERYONE' ) {
                            Media.addClass('facebook-iframe').removeClass('facebook-video');
                        } else {
                            Media.addClass('facebook-video').removeClass('facebook-iframe');
                        };

                        var ThumbPic = this.format[0].picture,
                            ThumbWidth = this.format[0].width,
                            ThumbHeight = this.format[0].height,
                            VideoUrl = this.format[0].embed_html,
                            TotalReactions = 0;

                        if( this.format[2] && this.format[2].height > 250 )
                        ThumbPic = this.format[2].picture,
                        ThumbWidth = this.format[2].width,
                        ThumbHeight = this.format[2].height,
                        VideoUrl = this.format[2].embed_html;

                        if( ThumbWidth == 0 || ThumbHeight == 0 )
                        ThumbPic = this.thumbnails.data[0].uri,
                        ThumbWidth = this.thumbnails.data[0].width,
                        ThumbHeight = this.thumbnails.data[0].height;

                        if( this.privacy.value != 'EVERYONE' )
                        VideoUrl = this.source;

                        // Adding cover photo if exist
                        if( self.facebookProfileCoverPhoto )
                        TopBanner.html('<div>')
                                 .children()
                                 .css( 'background-image', 'url(' + self.facebookProfileCoverPhoto + ')' );

                        AuthorPhoto.html('<img>')
                                   .children()
                                   .attr('src', data.picture.data.url);

                        AuthorName.text(data.name);
                        AuthorLink.html(AuthorName);

                        MediaLink.attr({ 'href': 'https://www.facebook.com' + this.permalink_url, 'target': '_blank' })
                                 .text(self.options.lightBoxSocialLinkText+' Facebook');

                        AuthorAndLink.html([AuthorPhoto, AuthorLink, MediaLink]);
                        
                        TopData.html([TopBanner, AuthorAndLink]);

                        CommentCounter.html(self.CommentsIcon)
                                      .append('<span>')
                                      .children('span')
                                      .text(this.comments.summary.total_count);

                        // Clear reactions
                        ReactionsCounter.html('');

                        // Reactions to the video
                        if( this.reactions_like.summary.total_count > 0 )
                        TotalReactions = TotalReactions + this.reactions_like.summary.total_count,
                        ReactionsCounter.append(LikesCounter);

                        if( this.reactions_love.summary.total_count > 0 )
                        TotalReactions = TotalReactions + this.reactions_love.summary.total_count,
                        ReactionsCounter.append(LoveCounter);

                        if( this.reactions_wow.summary.total_count > 0 )
                        TotalReactions = TotalReactions + this.reactions_wow.summary.total_count,
                        ReactionsCounter.append(WowCounter);

                        if( this.reactions_haha.summary.total_count > 0 )
                        TotalReactions = TotalReactions + this.reactions_haha.summary.total_count,
                        ReactionsCounter.append(HahaCounter);

                        if( this.reactions_sad.summary.total_count > 0 )
                        TotalReactions = TotalReactions + this.reactions_sad.summary.total_count,
                        ReactionsCounter.append(SadCounter);

                        if( this.reactions_angry.summary.total_count > 0 )
                        TotalReactions = TotalReactions + this.reactions_angry.summary.total_count,
                        ReactionsCounter.append(AngryCounter);

                        if ( TotalReactions > 0 )
                        ReactionsCounter.append('<span>').find('span').text(TotalReactions);

                        StatisticCounters.html([CommentCounter, ReactionsCounter]);

                        var CreatedTime = this.created_time.replace(/\+/g, '.');
                        PublishedTime.attr('date', CreatedTime).html( self.timeElapsed(CreatedTime) );

                        StatisticAndTime.html([StatisticCounters, PublishedTime]);

                        DescAndComments.html(StatisticAndTime); 

                        if( this.description && !self.isMobile )
                        MediaDesc.html( self.matchLinks( this.description ) ).insertAfter(StatisticAndTime); 

                        if( self.isMobile )
                        DescAndComments.html(StatisticAndTime);           

                        Caption.html([TopData, DescAndComments]);

                        Media.html(Caption)
                             .attr({
                                'width': ThumbWidth,
                                'height': ThumbHeight,
                                'video-url': VideoUrl,
                                'media-id': this.id,
                                'data-img': ThumbPic
                             });

                        if (self.options.socialIcon)
                        Media.append(FacebookIcon);
         
                        self.grid_item( Media, itemHeight, itemMargin, gradientAngle, tltX, tltY );

                        Media.clone().appendTo(self.$scrollArea);
                    });

                    self.get_social_data_success( NextSocNet, results, self.itemsLoadCnt );
                },
                error: function(data) {

                    console.log(data);
                    this.get_social_data_error( CurrSocNet, NextSocNet, results );
                }
            });

            // If all Facebook videos are downloaded
            if( NextSocNet && !this.isFacebookVideosLeft )
            this.get_social_data_end(  NextSocNet, results );
        },
        // This function is intended to update information about the Facebook object
        facebookGetItemData: function(item) {

            // Update elapsed time
            var UpdateTime = $(item).find('.post-published-time');
            UpdateTime.html( this.timeElapsed( UpdateTime.attr('date') ) );

            // Get profile banner
            if ( !$(item).find('.profile-banner div').length && !this.isMobile && !this.facebookProfileCoverPhoto )
            this.facebookGetBannerPic();
        },
        // This function is intended to get Facebook banner picture
        facebookGetBannerPic: function() {

            var self = this,
                BannerTepmImg = $('<img/>'),
                AuthorBanner = $('<div>').css({
                                    'opacity': 0,
                                    'transition': 'opacity ' + this.options.lightBoxSpeed + 'ms '
                               });

            this.lightBoxImage.find('.profile-banner').html(AuthorBanner);

            $.ajax({
                type: "GET",
                dataType: "jsonp",
                cache: false,
                crossDomain: true,
                url: 'https://graph.facebook.com/me?fields=albums{type,cover_photo}&access_token=' +
                     this.options.facebookAccessToken,
                success: function(data) {

                    $.each(data.albums.data, function(i, data) {

                        if(data.type == 'cover')
                        $.ajax({
                            type: "GET",
                            dataType: "jsonp",
                            cache: false,
                            crossDomain: true,
                            url: 'https://graph.facebook.com/' + 
                                 data.cover_photo.id + 
                                 '?fields=images&access_token=' +
                                 self.options.facebookAccessToken,
                            success: function(data) {

                                if(!data.images)
                                return;

                                self.facebookProfileCoverPhoto = data.images[0].source;
                                
                                if(data.images[2])
                                self.facebookProfileCoverPhoto = data.images[2].source;

                                $(BannerTepmImg).attr('src', self.facebookProfileCoverPhoto).on('load', function() {
                    
                                    $(AuthorBanner).css({
                                        'background-image': 'url(' + self.facebookProfileCoverPhoto + ')',
                                        'opacity': 1
                                    });

                                    $('.facebook-photo.social, .facebook-iframe.social, .facebook-video.social').each( function(i) {   
                                        if ( !$(this).find('.profile-banner div').length )
                                        $(this).find('.profile-banner').html( $(AuthorBanner).clone().css('opacity', '') );    
                                    });          
                                });
                            }
                        });   
                    });
                }       
            });
        },
        // This function is intended to create an iframe for a Facebook video
        facebookVideoCreateIframe: function(imgSrc, videoUrl) {
            
            this.VideoFrame.addClass('facebook-iframe')
                           .css('background-image','url(' + imgSrc + ')')
                           .html( $(this.PlayButton).clone() )
                           .children('svg')
                           .css({
                                'fill': this.options.socialControlColor,
                                'width': this.options.playButtonSize + 'px',
                                'opacity': this.options.socialControlOpacity,
                                'transition': this.options.lightBoxSpeed + 'ms ' + this.options.lightBoxTransitionStyle
                           });

            this.lightBoxImage.prepend( this.VideoFrame );

            var self = this;

            this.VideoFrame.on('touchend mouseup pointerup MSPointerUp', function(e){

                var FrameXdistance = e.originalEvent.pageX || e.originalEvent.touches[ 0 ].pageX,
                    FrameXdistance = Math.abs(self.lightBoxStartX - FrameXdistance),
                    FrameYdistance = e.originalEvent.pageY || e.originalEvent.touches[ 0 ].pageY,
                    FrameYdistance = Math.abs(self.lightBoxStartY - FrameYdistance),
                    TrstnDistance = self.lightBoxImage.outerWidth() / 100 * self.options.lightBoxTransitionDistance;       

                if ( $(this).find('iframe').length || 
                     FrameXdistance > TrstnDistance || 
                     Math.ceil(FrameYdistance) > Math.ceil(FrameXdistance) )
                return;

                var FbIframe = $('<iframe frameborder="0" allow="autoplay; encrypted-media">');

                FbIframe.css({
                            'opacity': '0',
                            'transition': self.options.lightBoxSpeed + 'ms ' + self.options.lightBoxTransitionStyle
                         })
                         .attr('src', $(videoUrl).attr('src').split('&width')[0] + '&autoplay=1&playsinline=1' );

                $(this).append(FbIframe)
                       .children('iframe')
                       .on("load", function() {
                            $(this).css('opacity', '1')
                                   .on('transitionend', function(){
                                        $(this).parent().removeAttr('style');
                                    });
                       });

                $(this).children('svg').attr('class', 'hide');
            });
        },
        // This function is intended to create an video tag for a Facebook video
        facebookVideoCreateVideo: function(imgSrc, videoUrl) {
            
            this.VideoFrame.addClass('facebook-video')
                      .css('background-image','url(' + imgSrc + ')')
                      .html( $(this.PlayButton).clone() )
                      .children('svg')
                      .css({
                            'fill': this.options.socialControlColor,
                            'width': this.options.playButtonSize + 'px',
                            'opacity': this.options.socialControlOpacity,
                            'transition': this.options.lightBoxSpeed + 'ms ' + this.options.lightBoxTransitionStyle
                      });

            this.lightBoxImage.prepend( this.VideoFrame );

            var self = this;

            this.VideoFrame.on('touchend mouseup pointerup MSPointerUp', function(e){

                var FrameXdistance = e.originalEvent.pageX || e.originalEvent.touches[ 0 ].pageX,
                    FrameXdistance = Math.abs(self.lightBoxStartX - FrameXdistance),
                    FrameYdistance = e.originalEvent.pageY || e.originalEvent.touches[ 0 ].pageY,
                    FrameYdistance = Math.abs(self.lightBoxStartY - FrameYdistance),
                    TrstnDistance = self.lightBoxImage.outerWidth() / 100 * self.options.lightBoxTransitionDistance;       

                if ( $(this).find('video').length || 
                     FrameXdistance > TrstnDistance || 
                     Math.ceil(FrameYdistance) > Math.ceil(FrameXdistance) )
                return;

                var FbVideo = $('<video autoplay controls>'),
                    FbVideoSource = $('<source>');

                FbVideo.css({
                    'opacity': '0',
                    'transition': self.options.lightBoxSpeed + 'ms ' + self.options.lightBoxTransitionStyle
                });

                FbVideoSource.attr({
                    'src': videoUrl,
                    'type': 'video/mp4'
                });

                FbVideo.html(FbVideoSource);

                $(this).append(FbVideo)
                       .children('video')
                       .on('loadstart', function() {
                            $(this).css('opacity', '1')
                                   .on('transitionend', function(){
                                        $(this).parent().removeAttr('style');
                                    });
                            $(this).siblings('svg').attr('class', 'hide');
                       });
            });
        },
        // This function is intended to get the total count of YouTube videos
        youtubeGetMediaCount: function(request, query) {

            if ( this.totalMedia < this.grid_sizing() * 3 )
            return;

            var self = this;

            $.ajax({
                type: "GET",
                dataType: "jsonp",
                cache: false,
                crossDomain: true,
                url: 'https://www.googleapis.com/youtube/v3/' + request[0] + 
                     '?part=snippet' + request[1] + query +
                     '&key=' + this.options.youtubeApiKey,
                success: function(data) {

                    if( data.pageInfo.totalResults )
                    self.youtubeTotal = data.pageInfo.totalResults,
                    self.totalMedia = self.totalMedia + data.pageInfo.totalResults;

                    var NextSocNet = self.socialNetworks.indexOf('youtube') + 1;

                    self.get_social_data_success( self.socialNetworks[ NextSocNet ] );
                }
            });    
        },
        // This function is intended to getting YouTube videos
        youtubeGetData: function(request, query, nextpage, results) {

            // Find out if another social network is set
            var CurrSocNet = this.socialNetworks[ this.currSocNet ];
            this.currSocNet++;
            if ( this.socialNetworks[ this.currSocNet ] )
            var NextSocNet = this.socialNetworks[ this.currSocNet ];
            this.currSocNetName = 'youtube';

            // Variables to create a layout
            var self = this,
                itemHeight = this.options.itemSize,
                itemMargin = this.itemMagrin + '%',
                gradientAngle = 'to bottom',
                tltX = 100 - itemHeight,
                tltY = tltX,
                Media = $('<div>').addClass('youtube'),
                Caption = $('<div>').addClass('caption'),
                TopData = $('<div>').addClass('social-top-data youtube'),
                TopBanner = $('<div>').addClass('profile-banner'),
                AuthorAndLink = $('<div>').addClass('caption-author-and-link'),
                AuthorLink = $('<a>').addClass('caption-author'),
                AuthorPhoto = $('<a>').addClass('caption-author-photo'),
                AuthorName = $('<span>').addClass('caption-author-name'),
                MediaLink = $('<a>').addClass('media-link youtube'),
                StatisticAndTime = $('<div>').addClass('caption-statistic-and-time'),
                StatisticCounters = $('<div>').addClass('youtube statistic-counters'),
                CommentCounter = $('<div>').addClass('comments-counter'),
                LikesCounter = $('<div>').addClass('likes-counter'),
                DislikeCounter = $('<div>').addClass('dislikes-counter'),
                PublishedTime = $('<span>').addClass('post-published-time'),
                YoutubeIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg'),
                YoutubeIconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path'),
                DescAndComments = $('<div>').addClass('description-and-comments'),
                MediaDesc = $('<div>').addClass('media-description'),
                CommentsBlock = $('<div>').addClass('comments-wrapper'),
                CommentsLoader = $('<div>').addClass('loader');

            if (this.options.gridStyle == 'tile')
            itemHeight = this.tileHeight,  
            itemMargin = 0,
            gradientAngle = '135deg',
            tltY = 0;

            // Creation of the YouTube icon
            YoutubeIcon.setAttribute('class','youtube');
            YoutubeIcon.setAttribute('viewBox','-379.5 20.5 400 400');
            YoutubeIcon.setAttribute('preserveAspectRatio','xMidYMax slice');
            YoutubeIcon.setAttribute('width','100%');
            YoutubeIconPath.setAttribute('d','M16.5,140.5c-8.33-60-60-56-60-56s-75.664-3.895-136-4c-89.251,'+
                                             '0-136,4-136,4s-52.999-3.331-60,56c-4,41.67-4,80-4,80'+
                                             's0.15,49.334,4,80c7.337,57.668,60,56,60,56s81.67,4,136,'+
                                             '4c67.67-0.105,136-4,136-4s51.005,4.337,60-56c3.85-23.329,4-80,4-80'+
                                             'S20.35,160.837,16.5,140.5z M-220.788,272.082L-220.5,159.5l108,'+
                                             '57L-220.788,272.082z');
            YoutubeIcon.appendChild(YoutubeIconPath);

            // Download data from YouTube if it is still available
            if( this.youtubeTotal == null || this.youtubeDataLoaded < this.youtubeTotal )
            this.socialDataLoading = true,
            $.ajax({
                type: "GET",
                dataType: "jsonp",
                cache: false,
                crossDomain: true,
                url: 'https://www.googleapis.com/youtube/v3/' + request[0] + 
                     '?part=snippet' + request[1] + query +
                     '&key=' + this.options.youtubeApiKey + 
                     '&maxResults=24' + nextpage,
                success: function(data) {

                    // If something went wrong, like a Rate Limit
                    if ( data.error ) {
                        self.get_social_data_error( CurrSocNet, NextSocNet, results );
                        console.log('Youtube error', data.error.message);
                        return;
                    };

                    self.itemsLoadCnt = data.items.length;
                    self.itemsRecount = data.pageInfo.resultsPerPage - self.itemsLoadCnt;

                    // If there is no videos
                    if( !data.items || data.items.length == 0 ) {
                        self.get_social_data_success( NextSocNet, results, 0 );

                        if( self.youtubeTotal == null )
                        self.youtubeTotal = 0;

                        if( data.items.length == 0 )
                        self.totalMedia = self.totalMedia - self.youtubeTotal;
                        self.youtubeTotal = self.youtubeDataLoaded + self.itemsLoadCnt;
                        self.totalMedia = self.totalMedia + self.youtubeTotal;

                        self.youtubeDataLoaded = self.youtubeTotal;
 
                        return;
                    };

                    // Calculating the total number of videos
                    if( !self.youtubeTotal ) {
                        self.youtubeTotal = data.pageInfo.totalResults;
                        self.totalMedia = self.totalMedia + data.pageInfo.totalResults;
                    } else {
                        self.totalMedia = self.totalMedia - self.youtubeTotal - self.youtubePrivateVideoCount - self.itemsRecount;
                        self.youtubeTotal = data.pageInfo.totalResults - self.youtubePrivateVideoCount - self.itemsRecount;
                        self.totalMedia = self.totalMedia + data.pageInfo.totalResults;
                    };

                    // Determine where to start the next download
                    if( data.nextPageToken ) {
                        self.youtubeNextPage = '&pageToken=' + data.nextPageToken;
                    } else {
                        self.youtubeNextPage = '';
                        self.totalMedia = self.totalMedia - self.youtubeTotal;
                        self.youtubeTotal = self.youtubeDataLoaded + self.itemsLoadCnt;
                        self.totalMedia = self.totalMedia + self.youtubeTotal;
                    };

                    // Slides creation
                    $(data.items).each( function(i) {

                        // Exclude private videos
                        if(data.items[i].snippet.title == 'Private video') {
                            self.youtubeTotal--;
                            self.totalMedia--;
                            self.itemsLoadCnt--;
                            self.youtubePrivateVideoCount++;
                            return;
                        };

                        self.totalDataLoaded++;
                        self.youtubeDataLoaded++;

                        if(request[0] == 'search')
                        var VideoId = data.items[i].id.videoId;

                        if(request[0] == 'playlistItems')
                        var VideoId = data.items[i].snippet.resourceId.videoId;

                        AuthorName.text(data.items[i].snippet.channelTitle);

                        AuthorPhoto.attr({
                                    'href': 'https://www.youtube.com/channel/' + data.items[i].snippet.channelId,
                                    'target': '_blank'
                                   });

                        AuthorLink.attr({
                                    'href': 'https://www.youtube.com/channel/' + data.items[i].snippet.channelId,
                                    'target': '_blank'
                                   })
                                   .html(AuthorName);           

                        MediaLink.attr({
                                    'href': 'https://www.youtube.com/watch?v='+VideoId,
                                    'target': '_blank'
                                  })
                                  .text(self.options.lightBoxSocialLinkText+' Youtube');

                        CommentCounter.html(self.CommentsIcon);
                        LikesCounter.html(self.LikeIcon);
                        DislikeCounter.html(self.DislikeIcon);

                        PublishedTime.attr('date', data.items[i].snippet.publishedAt)
                                     .html( self.timeElapsed(data.items[i].snippet.publishedAt) );

                        StatisticCounters.html([CommentCounter, LikesCounter, DislikeCounter]);
                        
                        AuthorAndLink.html([AuthorPhoto, AuthorLink, MediaLink]);
                        StatisticAndTime.html([StatisticCounters, PublishedTime]);
                        
                        TopData.html([TopBanner, AuthorAndLink]);

                        DescAndComments.html([StatisticAndTime, CommentsBlock, CommentsLoader]); 

                        if( data.items[i].snippet.description && !self.isMobile )
                        MediaDesc.html( self.matchLinks( data.items[i].snippet.description, 
                                                         'https://www.youtube.com/results?search_query=%23', 
                                                         'https://www.youtube.com/results?search_query=') ),
                        MediaDesc.insertAfter(StatisticAndTime); 

                        if( self.isMobile )
                        DescAndComments.html(StatisticAndTime);           

                        Caption.html([TopData, DescAndComments]);

                        Media.html(Caption)
                             .attr({
                                'video-id': VideoId,
                                'channel-id': data.items[i].snippet.channelId,
                                'data-img': data.items[i].snippet.thumbnails.high.url
                             });

                        if (self.options.socialIcon)
                        Media.append(YoutubeIcon);

                        self.grid_item( Media, itemHeight, itemMargin, gradientAngle, tltX, tltY );

                        Media.clone().appendTo(self.$scrollArea);
                    });

                    self.get_social_data_success( NextSocNet, results, self.itemsLoadCnt );
                },
                error: function (data) { 
                    
                    console.log(data);
                    this.get_social_data_error( CurrSocNet, NextSocNet, results );
                }
            });

            // If all YouTube videos are downloaded
            if( NextSocNet && self.youtubeDataLoaded == self.youtubeTotal )
            this.get_social_data_end(  NextSocNet, results );
        },
        // This function is intended to update information about the YouTube video
        youtubeGetItemData: function(item) {

            // Update elapsed time
            var UpdateTime = $(item).find('.post-published-time');
            UpdateTime.html( this.timeElapsed( UpdateTime.attr('date') ) );

            // Get profile banner
            if ( !$(item).find('.profile-banner div').length && !this.isMobile )
            this.youtubeGetBannerPic( $(item).attr('channel-id') );

            // Get profile picture
            if ( !$(item).find('.caption-author-photo img').length )
            this.youtubeGetProfilePic( $(item).attr('channel-id') );

            // Get statistic
            if( !$(item).find('.comments-counter span').length )
            this.youtubeGetVideoDetails( $(item), $(item).attr('video-id') );

            // Get comments
            var CommentsVal = $(item).find('.comments-counter span').text();

            if( !$(item).find('.comment-block').length && !this.isMobile && parseInt(CommentsVal) != 0 )
            this.youtubeGetComments( $(item).attr('video-id'), true );

            // Load more comments
            this.youtubeGetMoreComments( $(item).attr('video-id') );
        },
        // This function is intended to get YouTube banner picture
        youtubeGetBannerPic: function(channelid) {

            var BannerTepmImg = $('<img/>'),
                AuthorBanner = $('<div>').css({
                                    'opacity': 0,
                                    'transition': 'opacity ' + this.options.lightBoxSpeed + 'ms '
                               });

            this.lightBoxImage.find('.profile-banner').html(AuthorBanner);

            $.ajax({
                type: "GET",
                dataType: "jsonp",
                cache: false,
                crossDomain: true,
                url: "https://www.googleapis.com/youtube/v3/channels?part=brandingSettings&id="+channelid+"&key=" + this.options.youtubeApiKey,
                success: function(data) {

                    var BannerSrc = data.items[0].brandingSettings.image.bannerImageUrl;

                    $(BannerTepmImg).attr('src', BannerSrc).on('load', function() {
                        
                        $(AuthorBanner).css({
                            'background-image': 'url(' + BannerSrc + ')',
                            'opacity': 1
                        });

                        $('.youtube.social[channel-id="' + channelid + '"]').each( function(i) {   
                            if ( !$(this).find('.profile-banner div').length )
                            $(this).find('.profile-banner').html( $(AuthorBanner).clone().css('opacity', '') );    
                        });          
                    });
                }       
            });
        },
        // This function is intended to get YouTube profile picture
        youtubeGetProfilePic: function(channelid) {

            var AuthorPhoto = $('<img/>').css({
                                    'opacity': 0,
                                    'transition': 'opacity ' + this.options.lightBoxSpeed + 'ms '
                              });

            this.lightBoxImage.find('.caption-author-photo').prepend(AuthorPhoto);
  
            $.ajax({
                type: "GET",
                dataType: "jsonp",
                cache: false,
                crossDomain: true,
                url: "https://www.googleapis.com/youtube/v3/channels?part=snippet&id="+channelid+"&key=" + this.options.youtubeApiKey,
                success: function(data) {

                    var PhotoSrc = data.items[0].snippet.thumbnails.default.url;

                    $(AuthorPhoto).attr('src', PhotoSrc).on('load', function() {
                        
                        $(this).css( 'opacity', 1 );

                        $('.youtube.social[channel-id="' + channelid + '"]').each( function(i) {   
                            if ( !$(this).find('.caption-author-photo img').length )
                            $(this).find('.caption-author-photo').prepend( $(AuthorPhoto).clone().removeAttr('style') );    
                        });          
                    });
                }       
            });
        },
        // This function is intended to get YouTube video statistics
        youtubeGetVideoDetails: function(item, videoid) {

            var comentsCounter = this.lightBoxImage.find('.comments-counter'),
                likesCounter = this.lightBoxImage.find('.likes-counter'),
                dislikesCounter = this.lightBoxImage.find('.dislikes-counter'),
                StatTxtWrpr = '<span style="color: transparent; transition: color ' 
                              + this.options.lightBoxSpeed + 
                              'ms;"></span>';

            $.ajax({
                type: "GET",
                dataType: "jsonp",
                cache: false,
                crossDomain: true,
                url: "https://www.googleapis.com/youtube/v3/videos?part=statistics&id="+videoid+"&key="+this.options.youtubeApiKey,
                success: function(data) {

                    if (data.items[0])
                    comentsCounter.append( $(StatTxtWrpr).text(data.items[0].statistics.commentCount) ),
                    item.find('.comments-counter').append('<span>' + data.items[0].statistics.commentCount + '</span>'),
                    likesCounter.append( $(StatTxtWrpr).text(data.items[0].statistics.likeCount) ),
                    item.find('.likes-counter').append('<span>' + data.items[0].statistics.likeCount + '</span>'),
                    dislikesCounter.append( $(StatTxtWrpr).text(data.items[0].statistics.dislikeCount) ),
                    item.find('.dislikes-counter').append('<span>' + data.items[0].statistics.dislikeCount + '</span>');

                    setTimeout( function(){
                        comentsCounter.add(likesCounter).add(dislikesCounter).find('span').css('color', '');
                    }, 25);             
                }       
            });
        },
        // This function is intended to get YouTube video comments
        youtubeGetComments: function(id, show) {

            var self = this,
                CommentBlock = $('<div>').addClass('comment-block'),
                CommentAuthorImg = $('<a>').addClass('comment-author-img').attr('target', '_blank'),
                CommentCaption = $('<div>').addClass('comment-caption'),
                CommentAuthorName = $('<a>').addClass('comment-author-name').attr('target', '_blank'),
                CommentText = $('<span>').addClass('comment-text'),
                NextComments = '';

                if (show)
                this.lightBoxImage.find('.comments-wrapper')
                                  .css({
                                    'opacity': 0,
                                    'transition': 'opacity ' + this.options.lightBoxSpeed + 'ms '
                                  });

                if (!show)                  
                NextComments = '&pageToken=' + this.lightBoxImage.find('.description-and-comments').attr('next-comments');                

            $.ajax({
                type: 'GET',
                dataType: "jsonp",
                cache: false,
                crossDomain: true,
                url: "https://www.googleapis.com/youtube/v3/commentThreads?key=" +
                     this.options.youtubeApiKey + "&part=snippet&videoId=" +
                     id + "&order=relevance" +  NextComments,
                success: function (data) {

                    if (!data.items)
                    return;    

                    $.each(data.items, function(i, data) {
                                    
                        CommentAuthorImg.attr('href', data.snippet.topLevelComment.snippet.authorChannelUrl)
                                        .css('background-image', 'url(' + data.snippet.topLevelComment.snippet.authorProfileImageUrl + ')'); 
                        
                        CommentAuthorName.attr('href', data.snippet.topLevelComment.snippet.authorChannelUrl)
                                         .text(data.snippet.topLevelComment.snippet.authorDisplayName);            

                        CommentText.html( data.snippet.topLevelComment.snippet.textDisplay );
                        CommentText.find('a').attr('target', '_blank');         

                        CommentCaption.html([CommentAuthorName, CommentText]);
                        
                        CommentBlock.html([CommentAuthorImg, CommentCaption]);

                        self.lightBoxImage.add('.youtube.social[video-id="' + id + '"]')
                                          .find('.comments-wrapper')
                                          .append( $(CommentBlock).clone() ); 

                    });

                    if (show)
                    self.lightBoxImage.find('.comments-wrapper')
                                      .css( 'opacity', 1 )
                                      .on('transitionend', function() { $(this).removeAttr('style') });

                    if (!show)                
                    self.loadingComments = false;

                    if(data.nextPageToken)
                    self.lightBoxImage.add('.youtube.social[video-id="' + id + '"]')
                                      .find('.description-and-comments')
                                      .attr('next-comments', data.nextPageToken);

                    if(!data.nextPageToken)
                    self.lightBoxImage.add('.youtube.social[video-id="' + id + '"]')
                                      .find('.description-and-comments')
                                      .removeAttr('next-comments');

                    self.lightBoxImage.find('.loader').hide();                  
                }
            });
        },
        // This function is intended to download more YouTube video comments
        youtubeGetMoreComments: function(id) {

            var self = this;

            this.lightBoxImage.find('.description-and-comments').on('scroll', function() {

                if( $(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight ) {
                    
                    if( !self.loadingComments && $(this).attr('next-comments') )
                    $(this).find('.loader').show(),    
                    self.loadingComments = true,
                    self.youtubeGetComments( id, false );
                };
            });
        },
        // This function is intended to create an iframe for a YouTube video
        youtubeCreateIframe: function(imgSrc, videoId) {
            
            this.VideoFrame.addClass('youtube')
                           .css('background-image','url(' + imgSrc + ')')
                           .html( $(this.PlayButton).clone() )
                           .children('svg')
                           .css({
                                'fill': this.options.socialControlColor,
                                'width': this.options.playButtonSize + 'px',
                                'opacity': this.options.socialControlOpacity,
                                'transition': this.options.lightBoxSpeed + 'ms ' + this.options.lightBoxTransitionStyle
                           });

            this.lightBoxImage.prepend( this.VideoFrame );

            var self = this;

            this.VideoFrame.on('touchend mouseup pointerup MSPointerUp', function(e){

                var FrameXdistance = e.originalEvent.pageX || e.originalEvent.touches[ 0 ].pageX,
                    FrameXdistance = Math.abs(self.lightBoxStartX - FrameXdistance),
                    FrameYdistance = e.originalEvent.pageY || e.originalEvent.touches[ 0 ].pageY,
                    FrameYdistance = Math.abs(self.lightBoxStartY - FrameYdistance),
                    TrstnDistance = self.lightBoxImage.outerWidth() / 100 * self.options.lightBoxTransitionDistance;       

                if ( $(this).find('iframe').length || 
                     FrameXdistance > TrstnDistance || 
                     Math.ceil(FrameYdistance) > Math.ceil(FrameXdistance) )
                return;

                var YtbIframe = $('<iframe frameborder="0" allow="autoplay; encrypted-media">');

                YtbIframe.css({
                            'opacity': '0',
                            'transition': self.options.lightBoxSpeed + 'ms ' + self.options.lightBoxTransitionStyle
                         })
                         .attr('src', 'https://www.youtube.com/embed/'+videoId+'?'+
                                      'rel=0'+
                                      '&showinfo=0'+
                                      '&autoplay=1'+
                                      '&playsinline=1'+
                                      '&iv_load_policy=3'+
                                      '&modestbranding=1'+
                                      '&disablekb=1'+
                                      '&origin='+document.location.origin
                );

                $(this).append(YtbIframe)
                       .children('iframe')
                       .on("load", function() {
                            $(this).css('opacity', '1')
                                   .on('transitionend', function(){
                                        $(this).parent().removeAttr('style');
                                    });
                       });

                $(this).children('svg').attr('class', 'hide');
            });
        },
        // This function is intended to get the total count of Vimeo videos
        vimeoGetMediaCount: function(request, query) {

            if ( this.totalMedia < this.grid_sizing() * 3 )
            return;

            var self = this;

            $.ajax({
                type: "GET",
                dataType: "json",
                cache: false,
                crossDomain: true,
                url: 'https://api.vimeo.com/' + request + 
                     'videos?per_page=1' + query + 
                     '&access_token=' + this.options.vimeoAccessToken,
                success: function(data) {

                    if( data.total )
                    self.vimeoTotal = data.total,
                    self.totalMedia = self.totalMedia + data.total;

                    var NextSocNet = self.socialNetworks.indexOf('vimeo') + 1;

                    self.get_social_data_success( self.socialNetworks[ NextSocNet ] );
                }
            });    
        },
        // This function is intended to getting Vimeo videos
        vimeoGetData: function(request, query, nexpage, results) {

            // Find out if another social network is set
            var CurrSocNet = this.socialNetworks[ this.currSocNet ];
            this.currSocNet++;
            if ( this.socialNetworks[ this.currSocNet ] )
            var NextSocNet = this.socialNetworks[ this.currSocNet ];
            this.currSocNetName = 'vimeo';

            // Variables to create a layout
            var self = this,
                itemHeight = this.options.itemSize,
                itemMargin = this.itemMagrin + '%',
                gradientAngle = 'to bottom',
                tltX = 100 - itemHeight,
                tltY = tltX,
                Media = $('<div>').addClass('vimeo'),
                Caption = $('<div>').addClass('caption'),
                TopData = $('<div>').addClass('social-top-data vimeo'),
                TopBanner = $('<div>').addClass('profile-banner'),
                AuthorAndLink = $('<div>').addClass('caption-author-and-link'),
                AuthorLink = $('<a>').addClass('caption-author'),
                AuthorPhoto = $('<a>').addClass('caption-author-photo'),
                AuthorName = $('<span>').addClass('caption-author-name'),
                MediaLink = $('<a>').addClass('media-link vimeo'),
                StatisticAndTime = $('<div>').addClass('caption-statistic-and-time'),
                StatisticCounters = $('<div>').addClass('vimeo statistic-counters'),
                FavorCounter = $('<div>').addClass('favourite-icon'),
                CommentCounter = $('<div>').addClass('comments-counter'),
                PublishedTime = $('<span>').addClass('post-published-time'),
                VimeoIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg'),
                VimeoIconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path'),
                DescAndComments = $('<div>').addClass('description-and-comments'),
                MediaDesc = $('<div>').addClass('media-description'),
                CommentsBlock = $('<div>').addClass('comments-wrapper'),
                CommentsLoader = $('<div>').addClass('loader');

            if (this.options.gridStyle == 'tile')
            itemHeight = this.tileHeight,  
            itemMargin = 0,
            gradientAngle = '135deg',
            tltY = 0;

            // Creation of the Vimeo icon
            VimeoIcon.setAttribute('class','vimeo');
            VimeoIcon.setAttribute('viewBox','-180 -180 400 400');
            VimeoIcon.setAttribute('preserveAspectRatio','xMidYMax slice');
            VimeoIcon.setAttribute('width','100%');
            VimeoIconPath.setAttribute('d','M0,194c-55.5,0-67.5-109.833-79-138C-93.499,' +
                                           '4.834-103.5-49-127-55c-7.75-2-34,19-34,19l-19-25c22-18,'+
                                           '86.25-83.5,114-88 c33.75-5,53.833,18.216,61,64C2.754-35.599,'+
                                           '17,68,41,68c20.5,0,64-81.166,64-100c2.383-22.893-7.167-45.167-56-28 '+
                                           'c18.166-62.5,53.5-94,113-94c38.5,0,58,25.833,58,80C220-6.833,'+
                                           '82.5,194,0,194z');
            VimeoIcon.appendChild(VimeoIconPath);

            // Download data from Vimep if it is still available
            if( this.vimeoTotal == null || this.vimeoDataLoaded < this.vimeoTotal )
            this.socialDataLoading = true,
            $.ajax({
                type: "GET",
                dataType: "json",
                cache: false,
                crossDomain: true, 
                url: 'https://api.vimeo.com/' + request + 
                     'videos?per_page=24' + query + nexpage +
                     '&access_token=' + this.options.vimeoAccessToken,		
                success: function(data) {

                    // If something went wrong, like a Rate Limit
                    if (data.error) {
                        self.get_social_data_error( CurrSocNet, NextSocNet, results );
                        console.log('Vimeo error', data.error);
                        return;
                    };

                    // If there is no videos
                    if( !data.data || data.data.length == 0 ) {
                        self.get_social_data_success( NextSocNet, results, 0 );

                        if( self.vimeoTotal == null )
                        self.vimeoTotal = 0;

                        self.vimeoDataLoaded = self.vimeoTotal;
 
                        return;
                    };

                    // Determine where to start the next download
                    if( data.paging.next ) {
                        self.vimeoNextPage = '&page=' + parseInt( data.page + 1 );
                    } else {
                        self.vimeoNextPage = '';
                    };

                    // Calculating the total number of videos
                    if( !self.vimeoTotal )
                    self.vimeoTotal = data.total,
                    self.totalMedia = self.totalMedia + data.total;

                    self.itemsLoadCnt = data.data.length;

                    // Slides creation
                    $(data.data).each( function(i) {

                        self.totalDataLoaded++;
                        self.vimeoDataLoaded++;

                        if( this.categories[0] ) {

                            var TopBannerPic = this.categories[0].pictures.sizes[1].link;

                            if( this.categories[0].pictures.sizes[3] )
                            TopBannerPic = this.categories[0].pictures.sizes[3].link;

                            TopBanner.html('<div>')
                                     .children()
                                     .css( 'background-image', 'url(' + TopBannerPic + ')' );
                        };

                        var AuthorPhotoPic = this.user.pictures.sizes[1].link;
                        
                        if (this.user.pictures.sizes[3])
                        AuthorPhotoPic = this.user.pictures.sizes[3].link;

                        AuthorPhoto.attr({
                                        'href': this.user.link,
                                        'target': '_blank'
                                   })
                                   .html('<img>')
                                   .children()
                                   .attr('src', AuthorPhotoPic);

                        AuthorName.text(this.user.name);
                        AuthorLink.attr({ 'href': this.user.link, 'target': '_blank' })
                                  .html(AuthorName);

                        MediaLink.attr({ 'href': this.link, 'target': '_blank' })
                                 .text(self.options.lightBoxSocialLinkText+' Vimeo');

                        AuthorAndLink.html([AuthorPhoto, AuthorLink, MediaLink]);
                        
                        TopData.html([TopBanner, AuthorAndLink]);

                        FavorCounter.html(self.FavoriteIcon)
                                    .append('<span>')
                                    .children('span')
                                    .text(this.metadata.connections.likes.total);

                        CommentCounter.html(self.CommentsIcon)
                                      .append('<span>')
                                      .children('span')
                                      .text(this.metadata.connections.comments.total);

                        PublishedTime.attr('date', this.created_time)
                                     .html( self.timeElapsed(this.created_time) );

                        StatisticCounters.html([FavorCounter, CommentCounter]);
                        StatisticAndTime.html([StatisticCounters, PublishedTime]);

                        DescAndComments.html([StatisticAndTime, CommentsBlock, CommentsLoader]); 

                        if( this.description && !self.isMobile )
                        MediaDesc.html( self.matchLinks( this.description, 
                                                         'https://vimeo.com/search?q=%23', 
                                                         'https://vimeo.com/search?q=') ),
                        MediaDesc.insertAfter(StatisticAndTime); 

                        if( self.isMobile )
                        DescAndComments.html(StatisticAndTime);           

                        Caption.html([TopData, DescAndComments]);

                        var ThumbPic = this.pictures.sizes[1].link;

                        if(this.pictures.sizes[3])
                        ThumbPic = this.pictures.sizes[3].link;

                        Media.html(Caption)
                             .attr({
                                'width': this.width,
                                'height': this.height,
                                'video-id': this.uri.split('/videos/').pop(),
                                'data-img': ThumbPic
                             });

                        if (self.options.socialIcon)
                        Media.append(VimeoIcon);

                        self.grid_item( Media, itemHeight, itemMargin, gradientAngle, tltX, tltY );

                        Media.clone().appendTo(self.$scrollArea);
                    });

                    self.get_social_data_success( NextSocNet, results, self.itemsLoadCnt );
                },
                error: function (data) {

                    console.log(data.responseText);
                    this.get_social_data_error( CurrSocNet, NextSocNet, results );
                }
            });

            // If all Vimeo videos are downloaded
            if( NextSocNet && self.vimeoDataLoaded == self.vimeoTotal )
            this.get_social_data_end(  NextSocNet, results );
        },
        // This function is intended to update information about the Vimeo video
        vimeoGetItemData: function(item) {

            // Update elapsed time
            var UpdateTime = $(item).find('.post-published-time');
            UpdateTime.html( this.timeElapsed( UpdateTime.attr('date') ) );

            // Get comments
            var CommentsVal = $(item).find('.comments-counter span').text();

            if( !$(item).find('.comment-block').length && !this.isMobile && parseInt(CommentsVal) != 0 )
            this.vimeoGetComments( $(item).attr('video-id'), true );

            // Download more comments
            this.vimeoGetMoreComments( $(item).attr('video-id') );
        },
        // This function is intended to get Vimeo video comments
        vimeoGetComments: function(id, show) {

            var self = this,
                CommentBlock = $('<div>').addClass('comment-block'),
                CommentAuthorImg = $('<a>').addClass('comment-author-img').attr('target', '_blank'),
                CommentCaption = $('<div>').addClass('comment-caption'),
                CommentAuthorName = $('<a>').addClass('comment-author-name').attr('target', '_blank'),
                CommentText = $('<span>').addClass('comment-text'),
                NextComments = '';

            if (show)
            this.lightBoxImage.find('.comments-wrapper')
                              .css({
                                'opacity': 0,
                                'transition': 'opacity ' + this.options.lightBoxSpeed + 'ms '
                              });
            if (!show)                  
            NextComments = '&page=' + this.lightBoxImage.find('.description-and-comments').attr('next-comments');                

            $.ajax({
                type: 'GET',
                dataType: "json",
                cache: false,
                crossDomain: true,
                url: 'https://api.vimeo.com/videos/' + id + 
                     '/comments?per_page=20' +
                     NextComments
                     + '&access_token=' + 
                     this.options.vimeoAccessToken,
                success: function (data) {

                    if ( data.data.length == 0 )
                    return; 

                    $.each(data.data, function(i, data) {

                        var CommentAuthorPic = data.user.pictures.sizes[1].link;

                        if(data.user.pictures.sizes[3])
                        CommentAuthorPic = data.user.pictures.sizes[3].link;

                        CommentAuthorImg.attr('href', data.user.link)
                                        .css('background-image', 'url(' + CommentAuthorPic + ')'); 
                        
                        CommentAuthorName.attr('href', data.user.link)
                                         .text(data.user.name);

                        CommentText.html( self.matchLinks( data.text, 
                                                         'https://vimeo.com/search?q=%23', 
                                                         'https://vimeo.com/search?q=') );

                        CommentCaption.html([CommentAuthorName, CommentText]);
                        
                        CommentBlock.html([CommentAuthorImg, CommentCaption]);

                        self.lightBoxImage.add('.vimeo.social[video-id="' + id + '"]')
                                          .find('.comments-wrapper')
                                          .append( $(CommentBlock).clone() );
                    });

                    if (show)
                    self.lightBoxImage.find('.comments-wrapper')
                                      .css( 'opacity', 1 )
                                      .on('transitionend', function() { $(this).removeAttr('style') });
                    if (!show)                
                    self.loadingComments = false;

                    if(data.paging.next)
                    self.lightBoxImage.add('.vimeo.social[video-id="' + id + '"]')
                                      .find('.description-and-comments')
                                      .attr('next-comments', parseInt( data.page + 1 ));

                    if(!data.paging.next)
                    self.lightBoxImage.add('.vimeo.social[video-id="' + id + '"]')
                                      .find('.description-and-comments')
                                      .removeAttr('next-comments');

                    self.lightBoxImage.find('.loader').hide();
                
                },
                error: function (data) { 
                    console.log(data);
                }
            });
        },
        // This function is intended to download more Vimeo video comments
        vimeoGetMoreComments: function(id) {

            var self = this;

            this.lightBoxImage.find('.description-and-comments').on('scroll', function() {

                if( $(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight ) {
                    
                    if( !self.loadingComments && $(this).attr('next-comments') )
                    $(this).find('.loader').show(),    
                    self.loadingComments = true,
                    self.vimeoGetComments( id, false );
                };
            });
        },
        // This function is intended to create an iframe for a Vimeo video
        vimeoCreateIframe: function(imgSrc, videoId) {
            
            this.VideoFrame.css('background-image','url(' + imgSrc + ')')
                           .html( $(this.PlayButton).clone() )
                           .children('svg')
                           .css({
                                'fill': this.options.socialControlColor,
                                'width': this.options.playButtonSize + 'px',
                                'opacity': this.options.socialControlOpacity,
                                'transition': this.options.lightBoxSpeed + 'ms ' + this.options.lightBoxTransitionStyle
                           });

            this.lightBoxImage.prepend( this.VideoFrame );

            var self = this;

            this.VideoFrame.on('touchend mouseup pointerup MSPointerUp', function(e){

                var FrameXdistance = e.originalEvent.pageX || e.originalEvent.touches[ 0 ].pageX,
                    FrameXdistance = Math.abs(self.lightBoxStartX - FrameXdistance),
                    FrameYdistance = e.originalEvent.pageY || e.originalEvent.touches[ 0 ].pageY,
                    FrameYdistance = Math.abs(self.lightBoxStartY - FrameYdistance),
                    TrstnDistance = self.lightBoxImage.outerWidth() / 100 * self.options.lightBoxTransitionDistance;       

                if ( $(this).find('iframe').length || 
                     FrameXdistance > TrstnDistance || 
                     Math.ceil(FrameYdistance) > Math.ceil(FrameXdistance) )
                return;

                var VimeoIframe = $('<iframe frameborder="0" allow="autoplay; encrypted-media">');

                VimeoIframe.css({
                                'opacity': '0',
                                'transition': self.options.lightBoxSpeed + 'ms ' + self.options.lightBoxTransitionStyle
                            })
                            .attr('src', 'https://player.vimeo.com/video/'+videoId+'?'+
                                         'autoplay=true'+
                                         '&byline=0'+
                                         '&portrait=0'+
                                         '&badge=0'
                );

                $(this).append(VimeoIframe).children('iframe').on("load", function() { $(this).css('opacity', '1') });
                $(this).children('svg').attr('class', 'hide');
            });
        },
        // This function is intended to convert the time of creation of the post to the UNIX format
        unixTime: function(time) {
            if(/^[0-9]+$/.test(time) && time.toString().length < 13){
                return (parseInt(time) * 1000);
            } else if(/^[0-9]+$/.test(time)){
                return parseInt(time);
            }else{
                return Date.parse(time);
            }
        },
        // This function is intended to calculate the time elapsed since the post was created
        timeElapsed: function(time) {
            var date = new Date(Date.now() - this.unixTime(time));

            if(date.getUTCFullYear() < 1970) {
                return '<span>' + this.options.elapsedTimeFewSec + '</span>';
            } else if(date.getUTCFullYear() > 1970){
                return (date.getUTCFullYear() - 1970) + '<span> ' + this.options.elapsedTimeYrsAgo + '</span>';
            } else if(date.getUTCMonth() > 0){ 
                return  date.getUTCMonth() + '<span> ' + this.options.elapsedTimeMnthAgo + '</span>';
            } else if(date.getUTCDate() > 1 ){ 
                return  ((date.getUTCDate())-1) + '<span> ' + this.options.elapsedTimeDaysAgo + '</span>';
            } else if(date.getUTCHours() > 0 ){ 
                return   date.getUTCHours() + '<span> ' + this.options.elapsedTimeHrsAgo + '</span>';
            } else if(date.getUTCMinutes() > 0){ 
                return   date.getUTCMinutes() + '<span> ' + this.options.elapsedTimeMinAgo + '</span>';
            } else {
                return '<span>' + this.options.elapsedTimeLessThanMin + '</span>';
            };
        },
        // This function is intended to match the links and hashtags in the post
        matchLinks: function(string, hashtag, user) {
            string = string.replace(/()#([^\s!@#$%^&*()=+./,\[{\]};:'"?><]*)/ig, "$1<a href='"+hashtag+"$2' target='_blank'>#$2</a>");
            string = string.replace(/()@([^\s!@#$%^&*()=+/,\[{\]};:'"?><]*)/ig, "$1<a href='"+user+"$2' target='_blank'>@$2</a>");
            string = string.replace(/(^|\s)http:([^\s!*(),\[{\]};:'"><]*)/ig, "$1<a href='http:$2' target='_blank'>http:$2</a>");
            string = string.replace(/(^|\s)https:([^\s!*(),\[{\]};:'"><]*)/ig, "$1<a href='https:$2' target='_blank'>https:$2</a>");
            string = string.replace(/(^|\s)www([^\s!*(),\[{\]};:'"><]*)/ig, "$1<a href='https:$2' target='_blank'>https:$2</a>");
            return string;
        },
        // Resize function
        resize: function(gridStyle) {

            var self = this,
                initial_items = this.grid_sizing() * 3;

            this.itemInConfiguration = this[ gridStyle + '_el_sizes' ]( this.grid_sizing() )
            this.itemInWidth = this.itemInConfiguration[0];
            this.itemInHeight = this.itemInConfiguration[1];
            this.itemInMargin = this.itemInConfiguration[2];
            this.itemInFontSize = this.itemInConfiguration[3];
            this.itemInShadow = this.itemInConfiguration[4];
            this.itemInHalfShadow = this.itemInConfiguration[5];
            this.itemInControlFontSize = this.itemInConfiguration[6];

            this.wrapper_width();        
            this.wrapper_shadow_padding();

            this[ gridStyle + '_wrapper_height' ]( this.grid_sizing() ); 

            this[ gridStyle + '_scroll_area_height' ]( this.grid_sizing() );
            this.scroll_area_width();

            this.$scrollArea.children().each(function() {
                self.grid_item_sizing( this, 
                                       self.itemInWidth, 
                                       self.itemInHeight, 
                                       self.itemInMargin, 
                                       self.itemInFontSize, 
                                       self.itemInShadow, 
                                       self.itemInHalfShadow 
                );
            });

            if ( this.init_grid_size < this.grid_sizing() && this.$scrollArea.children('[data-img]').length > 0 ) 
            this.items.slice( 0, initial_items ).each( function() { 
                self.item_load( this);
            });

            this.slide();

            this.control_buttons_sizing( 
                self.itemInWidth, 
                self.itemInHeight, 
                self.itemInControlFontSize, 
                self.itemInShadow, 
                self.itemInHalfShadow 
            );

            if ( this.lightBoxOpened ) {

                this.lightBoxImage.css({
                    'transition':'',
                    'width':  this.sizing_lightbox_image( this.curLightBoxImg )[0] + 'px',
                    'height': this.sizing_lightbox_image( this.curLightBoxImg )[1] + 'px',
                    'top': this.sizing_lightbox_image( this.curLightBoxImg )[3] + 'px',
                    'left': this.sizing_lightbox_image( this.curLightBoxImg )[4] + 'px',
                });

                this.closeLightBox.css({
                    'transition':'',
                    'transition-delay':'',
                    'width':  this.sizing_lightbox_image( this.curLightBoxImg )[2] + 'px',
                    'height': this.sizing_lightbox_image( this.curLightBoxImg )[2] + 'px'
                });

                this.closeLightBox.children('div').css({
                    'width': this.lightbox_controls_size()[1] + '%',
                    'height': this.lightbox_controls_size()[1] + '%'
                });

                this.LightBoxCntlPrev.add(this.LightBoxCntlNext).css({
                    'transition': '',
                    'width':  this.sizing_lightbox_image( this.curLightBoxImg )[2] + 'px',
                    'height': this.sizing_lightbox_image( this.curLightBoxImg )[2] * 2 + 'px',
                    'top':  this.sizing_lightbox_image( this.curLightBoxImg )[5] + 'px',
                });

                this.LightBoxCntlPrev.add(this.LightBoxCntlNext).children('div').css({
                    'width': this.lightbox_controls_size()[0] + '%',
                    'height': this.lightbox_controls_size()[0] + '%'
                });

                this.LightBoxCntlPrev.add(this.LightBoxCntlNext).add(this.closeLightBox).find('span').css( 
                    'width', this.lightbox_controls_size()[2] + 'px' 
                );

                this.LightBoxCounter.css('height', this.sizing_lightbox_image( this.curLightBoxImg )[6] + 'px')
            };
        },
        // This function is intended to convert color from HEX to RGBA format
        hexToRgbA: function( hex, alpha ) {
            var c;
            if( /^#([A-Fa-f0-9]{3}){1,2}$/.test(hex) ) {
                c= hex.substring(1).split('');
                if( c.length== 3) {
                    c= [c[0], c[0], c[1], c[1], c[2], c[2]];
                }
                c= '0x'+c.join('');
                return 'rgba(' + [(c>>16)&255, (c>>8)&255, c&255].join(',') + ',' + alpha + ')';
            }
            throw new Error('Bad Hex value');
        },
        // Public property to get the total number of slides
        total_slides: function() {
            return this.totalMedia;
        },
        // Public property to get the current carousel index
        current_index: function() {
            return this.index;
        },
        // Public property to get the width of the carousel
        slider_width: function() {
            return this.$elmt.width();
        },
        // Public property to get the height of the carousel
        slider_height: function() {
            return this.$elmt.outerHeight().toFixed();
        },
        // This function is intended to completely destroy the plugin and clear all event listeners
        destroy: function() {

            this.index = 0;
            this.totalMedia = 0;
            this.keyIsDown = false;
            this.moveX = 0;
            this.translateX = 0;
            this.startX = 0;
            this.endX = 0;
            this.startY = 0;
            this.letItGo = null;
            this.mouseDown = false;
            this.carouselIsSliding = false;
            this.itemsLoading = false;
            this.carouselOnEnd = false;
            this.lightBoxMoveX = 0;
            this.lightBoxTranslateX = 0;
            this.lightBoxStartX = 0;
            this.lightBoxEndX = 0;
            this.lightBoxStartY = 0;
            this.lightBoxMouseDown = false;
            this.lightBoxOpened = false;
            this.lightBoxOnTrstn = false;
            this.lightBoxLoading = false;
            this.ableToCloseLB = true;
            this.socialAvailable = false;
            this.socialDataLoading = false;
            this.totalDataLoaded = 0;
            this.currSocNet = 0,
            this.loadingComments = false;
            this.itemsLoadCnt = 0;
            this.facebookPhotosTotal = null;
            this.facebookPhotosDataLoaded = 0;
            this.facebookPhotosPrecount = 0;
            this.facebookPhotosNextPage = '';
            this.isFacebookPhotosLeft = true;
            this.facebookPhotosCounted = false;
            this.facebookVideosTotal = null;
            this.facebookVideosDataLoaded = 0;
            this.facebookVideosPrecount = 0;
            this.facebookVideosNextPage = '';
            this.isFacebookVideosLeft = true;
            this.facebookVideosCounted = false;
            this.facebookProfileCoverPhoto = null;
            this.youtubeTotal = null;
            this.youtubeDataLoaded = 0;
            this.youtubeNextPage = '';
            this.vimeoTotal = null;
            this.vimeoDataLoaded = 0;
            this.vimeoNextPage = '';

            this.$controlNext.add( this.$controlPrev )
                             .removeAttr('style class')
                             .children(':first')
                             .off('click');

            this.$scrollArea.off('click touchstart touchmove mousedown mousemove mouseleave mouseup touchend transitionend')
                            .removeAttr('style class')
                            .children()
                            .remove();

            this.$elmt.off('mouseenter mouseleave')
                      .removeAttr('style class')
                      .children()
                      .remove();
        }
    };

    // Applying a plugin to a specified element
    $.fn.diamond = function(options) {
        var args = arguments,
            error = false,
            returns;

        if (options === undefined || typeof options === 'object') {
            
            return this.each(function () {

                if (!this._diamond) {
                    this._diamond = new Diamond(this, options);
                } else {   
                    this._diamond.destroy();
                    return new Diamond(this, options);
                };
            });
        } else if (typeof options === 'string') {
            
            this.each(function () {
                
                var instance = this._diamond;

                if (!instance) 
                throw new Error('No diamond applied to this element.');

                if (typeof instance[options] === 'function' && options[0] !== '_') {
                    returns = instance[options].apply(instance, [].slice.call(args, 1));
                } else {
                    error = true;
                }
            });

            if (error)
            throw new Error('No method "' + options + '" in Diamond.');

            return returns !== undefined ? returns : this;
        }
    };

})(window.jQuery);